export const translation_ES = {
  diveEditDashboard: "Accede al panel de edición.",
  passwordNotMatch: "Las contraseñas no coinciden",
  successChangedPassword: "¡Éxito! Has cambiado tu contraseña",
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Confirmar nueva contraseña",
  updatePassword: "Actualizar contraseña",
  pleaseInformPhoneNumber: "Por favor, informa tu número de teléfono.",
  dataEditedSuccess: "Datos editados con éxito",
  myData: "Mis datos",
  readingModePleaseContact:
    "Usuario de solo lectura. Contacta al administrador de tu empresa para acceder a las funciones de edición",
  youCanOnlyChangeItems: "Solo puedes modificar elementos que hayas creado.",
  actions: "Acciones",
  showingResults: "Mostrando {{start}} a {{end}} de {{total}} resultados",
  previousPage: "Página anterior",
  nextPage: "Página siguiente",
  firstPage: "Primera página",
  lastPage: "Última página",
  page: "Página",
  of: "de",
  navBar: {
    operationInsight: "Eventos operativos",
    forecastCharts: "Gráficos de pronóstico",
    sensorCharts: "Gráficos de sensores",
    dynamicUkcCharts: "Gráficos UKC dinámico",
    alerts: "Alertas",
    mooringLines: "Líneas de amarre",
    morphologyMap: "Mapa morfológico",
    admin: "Admin",
    myData: "Mis datos",
    changePassword: "Cambiar contraseña",
    userManager: "Gestor de usuarios",
    notificationManager: "Gestor de notificaciones",
    forecastChecker: "Verificador de pronósticos",
    settings: "Configuración",
    errorWhileGetMooringAuthentication:
      "¡Ups! Error al obtener la autenticación de amarre. Por favor contáctanos.",
    logout: "Cerrar sesión",
    portuguese: "Portugués",
    english: "Inglés",
    spanish: "Español",
    shareForecast: "Compartir pronóstico",
    new: "Nuevo",
    shareForecastWithOutLeaving: "¡Comparte el pronóstico sin salir de i4cast!",
    reportOccurrence: "Reportar ocurrencia",
    occurrences: "Ocurrencias",
    importOccurrence: "Importar ocurrencia",
    youAreGoingToBeRedirect: "Serás redirigido a otra página",
    errorWhileGetUKCAuthentication:
      "¡Ups! Error al obtener la autenticación de UKC dinámico. Por favor contáctanos.",
    manageStation: "Gestor de estaciones",
    performance: "Rendimiento",
    eventHistory: "Historial de eventos",
    eventAnalysis: "Análisis de eventos",
    watchTutorial: "Ver tutorial",
    learnHowToUse: "Aprende a usar i4cast",
    riverForecast: "Pronósticos de ríos",
    services: "Servicios",
    locations: "Ubicaciones",
  },
  login: {
    usernameNoLongerValid:
      "Lo sentimos, pero este nombre de usuario ha sido desactivado y ya no es válido.",
    passwordNotBeenChanged:
      "La contraseña no ha sido cambiada. Te pedimos que repitas la operación o contactes a contato@i4sea.com.",
    errorValidatingPassword: "Error al validar tu contraseña actual.",
    resetPassword: "Restablecer contraseña",
    logIn: "Iniciar sesión",
    verificationCodeSent: "¡Código de verificación enviado!",
    successWeveSentYouEmailPasswordReset:
      "¡Éxito! Te hemos enviado un correo electrónico con instrucciones para restablecer tu contraseña.",
    doneNewPasswordSaved: "¡Listo! Nueva contraseña guardada",
    successGoBackToLogin: "¡Éxito! Vuelve a iniciar sesión y bienvenido.",
    login: {
      usernameNoLongerValid:
        "Lo sentimos, pero este nombre de usuario ha sido desactivado y ya no es válido.",
      updateI4castData: "Actualiza tus datos para maximizar el uso de i4cast",
      resetPassword: "Restablecer contraseña",
      gotIt: "¡Entendido!",
      skip: "omitir",
      emailUsername: "Correo electrónico o usuario",
      password: "Contraseña",
      keepLogged: "Mantenerme conectado",
      userPasswordIncorrect:
        "Lo sentimos, el usuario o la contraseña no son correctos. Podemos ayudarte a recuperar tu",
      logInTitle: "Iniciar sesión",
      logIn: "Iniciar sesión",
      forgotUsername: "¿Olvidaste tu usuario?",
      forgotPassword: "¿Olvidaste tu contraseña?",
      alert: "Alerta",
      verificationCodeSent: "¡Código de verificación enviado!",
      successWeveSentYouEmailPasswordReset:
        "¡Éxito! Te hemos enviado un correo electrónico con instrucciones para restablecer tu contraseña.",
      doneNewPasswordSaved: "¡Listo! Nueva contraseña guardada",
      successGoBackToLogin: "¡Éxito! Vuelve a iniciar sesión y bienvenido.",
      itAppearsYouAreDisconnected:
        "Parece que estás desconectado. Por favor, verifica tu conexión a internet.",
      sorryWeSeemToHaveEncountered:
        "Lo sentimos, parece que hemos encontrado un problema con nuestro servidor. Por favor, inténtalo de nuevo más tarde.",
      hidePassword: "Ocultar contraseña",
      showPassword: "Mostrar contraseña",
      eyesClosed: "Ojos cerrados",
      eyesOpen: "Ojos abiertos",
    },
    forgotPassword: {
      recoverPassword: "Recuperar contraseña",
      next: "Siguiente",
      cancel: "Cancelar",
      thereWasProblem: "Hubo un problema",
      pleaseInputEmail: "¡Por favor, ingresa tu correo electrónico!",
      updatePassword: "Actualizar contraseña",
      newPassword: "Nueva contraseña",
      pleaseCheckEmail: "Por favor, revisa tu bandeja de correo",
      enterCodeVerification: "Ingresa tu código de verificación",
      pleaseInputVerificationCode:
        "Por favor, ingresa tu código de verificación",
      pleaseInputYourPassword: "Por favor, ingresa tu contraseña",
      pleaseInputYourNewPassword: "Por favor, ingresa tu nueva contraseña",
      pleaseInputYourNewPasswordAgain:
        "Por favor, ingresa tu nueva contraseña de nuevo",
      confirmNewPassword: "Confirmar nueva contraseña",
    },
    changePassword: {
      changePassword: "Cambiar contraseña",
      updatePassword: "Actualizar contraseña",
      cancel: "Cancelar",
      dataEditedSuccess: "Datos editados con éxito",
      currentPassword: "Contraseña actual",
      pleaseInputCurrentPassword: "Por favor, ingresa tu contraseña actual",
      newPassword: "Nueva contraseña",
      passwordNotMatch: "Las contraseñas no coinciden",
      pleaseInputYourNewPassword: "Por favor, ingresa tu nueva contraseña",
      pleaseInputYourNewPasswordAgain:
        "Por favor, ingresa tu nueva contraseña de nuevo",
      confirmNewPassword: "Confirmar nueva contraseña",
      success: "Éxito",
      error: "Error",
    },
    newPasswordForm: {
      verificationCode: "Código de verificación",
      newPassword: "Nueva contraseña",
      resetPassword: "Restablecer contraseña",
      returnToLogin: "Volver al inicio de sesión",
      verificationCodePasswordIncorrect:
        "Código de verificación o contraseña incorrectos.",
    },
    recoverPasswordForm: {
      typeYourEmail: "Escribe tu correo electrónico",
      sendInstructionsByEmail: "Enviar instrucciones por correo electrónico",
      emailIncorrect: "Correo electrónico incorrecto.",
      returnToLogin: "Volver al inicio de sesión",
    },
    signIn: {
      alert: "Alerta",
      updateI4castData: "Actualiza tus datos para maximizar el uso de i4cast",
      gotIt: "¡Entendido!",
      skip: "omitir",
      thereWasAProblemWithLogin:
        "Hubo un problema con el inicio de sesión, verifica tus credenciales.",
      user: "Usuario",
      password: "Contraseña",
      logIn: "Iniciar sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
    },
  },
  notificationManager: {
    pleaseEnterMessageTitle: "Por favor, ingresa un título para el mensaje.",
    pleaseEnterMessageContent: "Por favor, ingresa el contenido del mensaje.",
    confirm: "Confirmar",
    confirmPushNotificationSent:
      "¿Confirmar el envío de notificación push a {{totalUsers}} usuarios objetivo?",
    send: "Enviar",
    cancel: "Cancelar",
    selectCompany: "Selecciona una empresa",
    next: "Siguiente",
    previous: "Anterior",
    sendPushNotification: "Enviar notificación push",
    pushNotificationSentSuccessfully: "Notificación push enviada con éxito",
    submissionFailed: "Error en el envío",
    checkModifingInformationResubmiting:
      "Por favor, verifica y modifica la siguiente información antes de reenviar.",
    tryAgain: "Intentar de nuevo",
    allClearYouDontHaveNewMessages: "¡Todo listo! No tienes mensajes nuevos.",
    unreadNotification: "Notificación no leída",
    markAllAsRead: "Marcar todo como leído.",
    notifications: "Notificaciones",
    sendNewPushes: "Enviar nuevos pushes",
  },
  oceanWeatherIntelligence: {
    errorGeneratingInsight:
      "¡Ups! Hay un problema al generar los eventos para esta ubicación específica y algunos de ellos se han vuelto inaccesibles. Por favor, contáctanos para más información.",
    errorGetChartData:
      "Error al intentar obtener datos para el gráfico. Por favor contáctanos.",
    environmentalVariablesNotFound:
      "¡Ups! ¡Variables ambientales no encontradas para esta ubicación!",
    insightIsCausedBy: "El evento es causado por:",
    end: "Fin",
    start: "Inicio",
    summary: "Resumen",
    probability: "Probabilidad",
    to: "a",
    rare: "Muy baja",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    almostCertain: "Muy alta",
    locationInsight: "Ubicación/Evento",
    riskExtreme: "Riesgo extremo",
    riskHigh: "Riesgo alto",
    riskModerate: "Riesgo moderado",
    riskLow: "Riesgo bajo",
    probabilityRisk: "Probabilidad",
    severity: "Severidad",
    riskMatrix: "Matriz de riesgo",
    impactedArea: "de área impactada",
    impactedPoints: "de los puntos afectados",
    pointsFraction: "{{affected}} de {{total}}",
    affectedPointsSuffix: "puntos afectados",
    pointsWithoutForecast_one: "{{count}} punto sin pronóstico disponible",
    pointsWithoutForecast_other: "{{count}} puntos sin pronóstico disponible",
    affectedPointsDetail: "Puntos con ocurrencia",
    pointIndex: "Punto {{index}}",
    point: "Punto",
    area: "Área",
    multipoint: "Múltiples puntos",
    processing: "procesando",
    error: "error",
    // workspace#385 (US2): los cinco estados de una fila de area.
    // notPlanned NUNCA debe leerse como "no ocurre".
    rowState: {
      // ⚠️ Em INGLES nos tres idiomas, de proposito (decisao do time, 11/09/2026).
      // 📖 Esta frase era o marcador que o backend concatenava no NOME do evento
      // (`[No upcoming events!]`), entao e o texto que os usuarios ja liam em
      // qualquer idioma. Agora que o marcador saiu do nome, o rotulo abaixo e o
      // unico lugar que a diz -- e a diz com as mesmas palavras de antes.
      doesNotOccur: "No upcoming events!",
      neverWarms: "sin modelo para las variables",
      calculating: "calculando",
      notPlanned: "calculando",
      unavailable: "no se pudo verificar",
    },
    errorWhileSaveSort:
      "Ocurrió un error al guardar el orden. Por favor contáctanos.",
    errorSortListPermission:
      "No tienes permiso para ordenar la lista. Por favor, contacta al administrador.",
    errorWhileFavoriteDashboard:
      "Ocurrió un error al establecer el tablero como favorito. Por favor contáctanos.",
    oceanWeatherIntelligence: {
      clickGoBackPastInsights: "Historial de eventos",
      needSelectDashboardPastInsight:
        "¡Ups! Necesitas seleccionar un tablero para volver al pronóstico pasado",
      diveOperationInsights: "Accede a los Eventos operativos.",
      editDashboard: "Editar tablero",
      selectDashboard: "Selecciona un tablero",
      needSelectDashboardAddLocation:
        "¡Ups! Necesitas seleccionar un tablero para agregar una ubicación",
      editLocation: "Editar ubicación",
      editInsight: "Editar evento",
      currentInsight: "Evento actual",
      videoTutorials: "Tutoriales en video",
      time: "Hora:",
      operationInsights: "Eventos operativos",
      selectDashboardInsight: "Selecciona un tablero para ver sus eventos",
      dashboards: "Tableros",
      locations: "Ubicaciones",
      insights: "Eventos",
      weStillDontHaveAnyDashboard:
        "Todavía no tenemos ningún tablero registrado.",
      letsGo: "¿Empezamos?",
      addLocation: "Agregar ubicación",
      addLocationInsightToYourDashboard:
        "Para ver el gráfico, agrega una ubicación. Haz clic en 'Agregar ubicación' para comenzar. 😉",
      almostThereCreateInsightVisualizeChart:
        "¡Casi listo! Para crear un evento y visualizar el gráfico",
      clickHere: "haz clic aquí",
      selectService: "Selecciona un servicio",
      showShifts: "Mostrar en el gráfico",
      serviceShift: "Turno de servicio",
      until: "hasta",
      createServiceAndVisualize:
        "Registra un servicio y visualízalo junto al gráfico de eventos",
      createService: "Registrar servicio",
      newService: "¡Nuevo!",
      showServiceChart: "Mostrar servicio en el gráfico",
      selectAserviceToView:
        "Selecciona un servicio para ver tus turnos en el gráfico Gantt, junto con información de pronósticos para una mejor planificación.",
      probability: "PROBABILIDAD",
      total: "Total",
      insightsWithProbability:
        "Aquí tienes un consejo: cuando veas [Probabilidad], la posibilidad de que ocurra el evento está disponible.",
      checkTheRiskLevels:
        "Mira cómo se representan los colores de riesgo de los eventos en la matriz de riesgo.",
      clickToLearnMore: "¡Haz clic para saber más!",
      probabilitySwitch: "Probabilidad",
      whenYouDisable:
        "Desactiva las probabilidades de los eventos en el gráfico, mostrándolos de forma determinista.",
      leaveYourFeedback: "Deja tu comentario",
      notUsefulAtAll: "1 - Nada útil",
      veryUseful: "5 - Muy útil",
      thanksForFeedback: "¡Gracias por tu comentario! 🙌",
      close: "Cerrar",
      errorSortingList: "Error al ordenar la lista",
      thereAreInsightsWithErrors:
        "No se pudo generar uno o más eventos de área. Intenta ajustar las condiciones o reposicionar el área en el mapa. Si el problema persiste, contacta al soporte.",
    },
    insightAlert: {
      alertRemovalFailed: "Error al eliminar la alerta. Contáctanos",
      selectDashboardFilterLocation:
        "Por favor, selecciona un tablero para filtrar la ubicación",
      alert: "Alerta",
      active: "Activa",
      insight: "Evento",
      location: "Ubicación",
      dashboard: "Tablero",
      filterDashboard: "Filtrar un tablero",
      filterLocation: "Filtrar una ubicación",
      createNewAlert: "Crear nueva alerta",
      delete: "Eliminar",
      selectRecipient: "Selecciona un destinatario",
      users: "Usuarios",
      userName: "nombreUsuario",
      addAlert: "Agregar alerta",
      editAlert: "Editar alerta",
      add: "Agregar",
      edit: "Editar",
      cancel: "Cancelar",
      alertName: "Nombre de la alerta",
      pleaseInputAlertName: "¡Por favor, ingresa el nombre de la alerta!",
      alertNameExceedCharactersLimit:
        "¡El nombre de la alerta excede el límite de 100 caracteres!",
      status: "Estado",
      selectDashboardFromList: "¡Por favor, selecciona un tablero de la lista!",
      selectLocationFromList:
        "¡Por favor, selecciona una ubicación de la lista!",
      selectInsightFromList: "¡Por favor, selecciona un evento de la lista!",
      upTo: "Tiempo de anticipación",
      selectTimeBeforeEvent:
        "¡Por favor, selecciona un tiempo de anticipación antes del evento!",
      minutes: "minutos",
      hour: "hora",
      hours: "horas",
      day: "día",
      days: "días",
      notificationName: "Nombre de la notificación",
      notificationNameExceedCharactersLimit:
        "¡El nombre de la notificación excede el límite de 100 caracteres!",
      description: "Descripción",
      inputLocationSummary: "Por favor, ingresa el resumen de la ubicación",
      minimunEventDuration: "Duración mínima del evento",
      eventTimeRange: "Rango de tiempo del evento",
      insightLocationTimezone: "*Zona horaria de la ubicación del evento",
      otherConfigurationOptions: "Otras opciones de configuración",
      configurationCommingSoon: "Esta configuración estará disponible pronto",
      eventStart: "Inicio del evento",
      eventFinish: "Fin del evento",
      recipient: "Destinatario",
      errorGetUserAlert:
        "Error al obtener el usuario para la alerta. Por favor contáctanos.",
      errorGetDashboardAlert:
        "Error al obtener el tablero para la alerta. Por favor contáctanos.",
      errorGetLocationAlert:
        "Error al obtener la ubicación para la alerta. Por favor contáctanos.",
      errorGetInsightAlert:
        "Error al obtener el evento para la alerta. Por favor contáctanos.",
      errorGetAlertsData:
        "Error al obtener los datos de alertas. Por favor contáctanos.",
      errorLoadingEnvironmentalVariables:
        "Error al cargar las variables ambientales. Verifique su conexión e intente nuevamente.",
      retryLoadEnvVariables: "Intentar de nuevo",
      errorDeleteAlerts:
        "Error al eliminar las alertas. Por favor contáctanos.",
      errorAddAlert: "Error al agregar la alerta. Por favor contáctanos.",
      errorUpdateAlert: "Error al actualizar la alerta. Por favor contáctanos.",
      errorConflict:
        "Ya existe una alerta con esta plantilla. Encuéntrala en la lista a continuación para editarla.",
      insightAlerts: "Alertas",
      beforeEventsStart: "Antes del inicio del evento",
      notification: "Notificación",
      areYouSureWantDeleteThisAlert:
        "¿Estás seguro de que deseas eliminar esta alerta?",
      allUsers: "Todos los usuarios",
      yes: "Sí",
      no: "No",
      valueRequired: "El valor es obligatorio",

      thisIsHasNoWhatsapp: "Este usuario no tiene WhatsApp registrado",
      createFromTemplate: "Crear desde una plantilla",
      createFromScratch: "Crear desde evento",
      createCustomAlert: "Crear alerta personalizada",
      createdFromScratch: "Creada desde evento",
      linkedToInsight: "Vinculada a evento",
      alertsOver3Days:
        "Los pronósticos más allá de 3 días son menos certeros, por lo que las alertas tienen más probabilidades de cambiar o incluso ser canceladas.",
      alertInfo: "Información de la alerta",
      alertTemplate: "Plantilla de alerta",
      alertType: "Categoría de riesgo",
      insightBadge: "Evento",
      locationColumn: "Ubicación",
      alertTemplateArea: "Área de alerta",
      exampleRisk: "Ej. riesgo de caída de contenedor",
      alertConditions: "Condiciones de alerta",
      monitoredArea: "Área monitoreada",
      locationType: "Tipo de ubicación",
      point: "Punto",
      pointDescription:
        "Ideal para monitorear eventos en una ubicación específica.",
      area: "Área",
      areaDescription:
        "Ideal para monitorear eventos alrededor de tu ubicación de interés.",
      pointDetails: "Detalles del punto",
      back: "Atrás",
      region: "Región",
      station: "Estación",
      pleaseSelectRegionFromList:
        "Por favor, selecciona una región de la lista",
      pleaseSelectStationFromList:
        "Por favor, selecciona una estación de la lista",
      deliveryChannel: "Canal de entrega",
      enabledDeliveryChannels: "Canales de entrega habilitados",
      atLeastOneChannelRequired: "Selecciona al menos un canal de entrega",
      userToReceiveAlert: "Usuarios que recibirán la alerta",
      comingSoon: "próximamente",
      new: "Nuevo",
      save: "Guardar cambios",
      saving: "Guardando...",
      invalidStationRegionFormat: "Formato de región de estación inválido",
      createAndCustomizeAlert:
        "Crea y personaliza alertas para ti y tu equipo, y recibe notificaciones sobre eventos climáticos importantes.",
      filter: "Filtrar",
      port_closure: "Riesgo de cierre de puerto",
      extreme_wind: "Riesgo de vendaval",
      extreme_rain: "Riesgo de inundación",
      rough_sea: "Riesgo de marejada",
      no_category: "Sin categoría",
      tree_fall: "Riesgo de caída de árboles",
      roof_damage: "Riesgo de daño en techos",
      landslide: "Riesgo de deslizamiento",
      extreme_heat: "Riesgo de calor extremo",
      wildfire: "Riesgo de incendio forestal",
      fog: "Riesgo de niebla",
      low_visibility: "Riesgo de baja visibilidad",
      lightning_storm: "Riesgo de tormentas eléctricas",
      clear: "Limpiar",
      filtrate: "Filtrar",
      filterList: "Filtrar lista",
      searchByAlert: "Buscar por nombre de alerta",
      searchByUserName: "Buscar por nombre de usuario",
      duplicateAlertTemplate:
        "Ya tienes una alerta usando esta plantilla. Por favor, edita la alerta existente o elige una plantilla diferente.",
      clickToLearnMore: "¡Haz clic para saber más!",
      withReady:
        "Con plantillas de alerta listas para usar, eliges un área y monitoreas",
      portClosureRisk:
        "riesgos de cierre de puerto y riesgos operacionales y estructurales",
      moreComingSoon: "(más próximamente)",
      whatIsAndHowItWorks: "¿Qué es y cómo funciona?",
      keepYourNumber:
        "Mantén tu número actualizado para recibir notificaciones en tiempo real.",
      gotIt: "Entendido",
      theBigDifference:
        "La gran diferencia con esta nueva alerta es el monitoreo por área de tu operación, además del envío directo por WhatsApp.",
      alertTitle: "Riesgo de seguridad operacional, estructural y ambiental",
      alertPeriod:
        "📅 Entre: <strong>Sábado (26) a las 3pm</strong> y <strong>11am Domingo (27)</strong>",
      environmentalConditionsTitle: "🌍 Condiciones ambientales:",
      environmentalConditionWaves: "• Olas entre 3.5 y 4.5 m",
      environmentalConditionWinds: "• Vientos entre 28 y 35 nudos",
      expectedImpactsTitle: "Descripción de la alerta:",
      impactDamage: "• Daños a estructuras y equipos",
      impactSafety: "• Riesgo para la seguridad del personal",
      impactInterruption: "• Interrupción de la operación",
      alertNote:
        "Alerta inicial. Estamos monitoreando y te notificaremos en caso de cambios o cancelación.",
      newAlertViaWpp: "Nuevas alertas vía WhatsApp",
      exampleAlert: "Ejemplo de alerta:",
      weVeRedesigned:
        "Hemos rediseñado el centro de alertas, y ahora incluye alertas de riesgo regional enviadas por WhatsApp,",
      // Template titles
      extremeHeatTitle: "Riesgo de calor extremo",
      extremeWindTitle: "Riesgo de vendaval",
      extremeRainTitle: "Riesgo de inundación",
      landslideTitle: "Riesgo de deslizamiento",
      wildfireTitle: "Riesgo de incendio forestal",
      treeFallTitle: "Riesgo de caída de árboles",
      roofDamageTitle: "Riesgo de daños en techos",
      roughSeaTitle: "Riesgo de marejada",
      fogTitle: "Riesgo de niebla",
      lowVisibilityTitle: "Riesgo de baja visibilidad",
      lightningStormTitle: "Riesgo de actividad eléctrica",
      noCategoryTitle: "Alerta operacional",
      portClosureTitle: "Riesgo de cierre de puerto",
      // Template descriptions
      extremeHeatDescription:
        "Las temperaturas muy elevadas pueden afectar a los equipos y las operaciones.",
      extremeWindDescription:
        "Vientos fuertes y ráfagas intensas pueden causar daños e interrupciones.",
      extremeRainDescription:
        "Las lluvias intensas aumentan el riesgo de inundaciones e impacto en los accesos.",
      landslideDescription:
        "El alto volumen de lluvia aumenta el riesgo de deslizamientos.",
      wildfireDescription:
        "El clima seco y el viento favorecen la propagación del fuego.",
      treeFallDescription:
        "El suelo saturado y el viento aumentan el riesgo de caídas.",
      roofDamageDescription:
        "Las ráfagas intensas pueden causar daños en las cubiertas.",
      roughSeaDescription:
        "Las olas altas y el mar agitado pueden comprometer las operaciones marítimas.",
      fogDescription:
        "La niebla puede reducir la visibilidad y afectar la seguridad.",
      lowVisibilityDescription:
        "La visibilidad reducida puede impactar las operaciones.",
      lightningStormDescription:
        "Las tormentas con descargas eléctricas organizadas aumentan el riesgo para personas, equipos y operaciones externas.",
      noCategoryDescription:
        "Se han identificado condiciones ambientales fuera de lo normal. Evalúe los posibles impactos en la operación.",
      // Legacy descriptions (kept for backwards compatibility)
      possibilityOfImpacts:
        "Posibles impactos en activos y operaciones, con prioridad en la seguridad del equipo.",
      potentialSuspension:
        "Posible suspensión de maniobras, retrasos logísticos y necesidad de replanificar las operaciones del terminal.",
      possibilityOfFlooding:
        "Posibilidad de inundación con impactos en activos y continuidad operacional.",
      customMessage: "Mensaje personalizado",
      alertTitleDescribe: "Título de la alerta",
      alertTitlePlaceholder: "Título que se mostrará en la alerta",
      titleThatWillBe:
        "Título que se mostrará al inicio del mensaje de alerta. Sé claro y objetivo.",
      alertDescription: "Descripción de la alerta",
      alertDescriptionPlaceholder: "Descripción de la alerta",
      describeTheImpact:
        "Describe el impacto o las acciones que debe tomar el equipo.",
      viewMessage: "Ver mensaje",
      customizeMessage: "Personalizar mensaje",
      sendConfig: {
        title: "Configuración de envío",
        advanceTime: "Tiempo de anticipación",
        selectPlaceholder: "Seleccionar",
        receipt: "También recibir",
        dayPeriodOfInterest: "Período del día de interés",
        eventCanBeCapturedAnytime:
          "El evento puede ser capturado en cualquier momento del día",
        timezoneHelperText: "Zona horaria de la ubicación del evento",
        eventCanBeCapturedBetween: "El evento puede ser capturado entre",
        minimumEventDuration: "Duración mínima del evento",
        minMaxAdvanceTime: "Tiempo de anticipación mínimo/máximo",
        advanceTimeSubtitle:
          "La alerta capturada solo se enviará si está dentro de la ventana de tiempo de anticipación mínimo y máximo.",
        alertsOver3DaysWarning:
          "Las alertas de más de 3 días tienen mayor probabilidad de cambio o cancelación.",
        minMaxValidationError:
          "El tiempo mínimo debe ser menor que el tiempo máximo",
        minGapValidationError: "Brecha mínima de 1 hora entre valores",
        selectedInterval: "Intervalo seleccionado",
        receiptOptions: {
          sendUpdates: "Actualizaciones frecuentes del evento",
          sendCancellations: "Cancelaciones del evento",
        },
      },
      alertIcon: "🚨 Alerta:",
      selectedUsers: "Usuarios seleccionados",
      channelMismatchWarning: "Advertencia: Canales no verificados",
      someUsersDoNotHaveVerifiedChannels:
        "Algunos usuarios seleccionados no tienen todos los canales de entrega verificados.",
      selectedChannelsNotVerified: "Canales seleccionados sin verificación",
      usersWithoutChannelWillNotReceiveNotifications:
        "Los usuarios sin el canal verificado no recibirán notificaciones a través de ese canal.",
      goBack: "Volver",
      saveAnyway: "Guardar de todos modos",
      inLocation: "en",
      thisFieldRequired: "Este campo es obligatorio",
      continue: "Continuar",
      drawArea: "Dibujar un área",
      importGeojson: "Importar GeoJSON",
      selectSavedArea: "Seleccionar área guardada",
      selectAreaAboveToVisualize: "Selecciona el área arriba para visualizar.",
      selectAlertType: "Selecciona el tipo de alerta:",
      editYourArea:
        "Arrastra los puntos azules para editar el polígono. Haz clic en 'Confirmar' cuando hayas terminado.",
      drawYourArea:
        "Dibuja los límites de tu área punto por punto, cada clic establece uno de los límites.",
      confirmArea: "Confirmar",
      clearArea: "Limpiar",
      invalidArea:
        "Asegúrate de que el polígono esté ubicado cerca de tus estaciones registradas.",
      invalidPoint: "Selecciona un punto cerca de tus estaciones registradas.",
      backToPrevious: "Atrás",
      selectStationOnMap: "Selecciona una estación en el mapa.",
      selectPointOrStationOnMap:
        "Selecciona un punto existente aquí o en el mapa, o haz clic directamente para crear uno nuevo.",
      searchStationOrCoordinates: "Buscar estación o lat,lon",
      searchAcceptsCoordinates: "La búsqueda acepta coordenadas lat/lon.",
      noResultsFound: "No se encontraron resultados",
      customPoint: "Punto seleccionado",
      saveStation: "Guardar estación",
      stationSaved: "Guardada",
      stationName: "Nombre de la estación",
      stationNamePlaceholder: "Ingresa un nombre para la estación",
      coordinates: "Coordenadas",
      stationSavedSuccess: "¡Estación guardada con éxito!",
      errorSavingStation: "Error al guardar la estación",
      confirmPoint: "Confirmar",
      clearSelection: "Limpiar selección",
      selectPointOnMap: "Seleccionar en el mapa",
      selectedStation: "Estación seleccionada",
      changeStation: "Cambiar",
      type: "Tipo",
      group: "Grupo",
      addNewGroup: "Nuevo grupo",
      addNewCondition: "Nueva condición",
      isGreaterThan: "es mayor que",
      isEqualToOrGreaterThan: "es igual o mayor que",
      isEqualTo: "es igual a",
      isLessThan: "es menor que",
      isEqualToOrLessThan: "es igual o menor que",
      and: "Y",
      or: "O",
      removeGroup: "Eliminar grupo",
      noMacroRegionOriginWasFound:
        "No se encontró ninguna macroregión de origen.",
      pleaseSelectPointOrArea: "* Por favor, selecciona un punto o área.",
      pleaseDrawAnArea:
        "* Por favor, dibuja un área en el mapa o importa una existente.",
      selectAreaPlaceholder: "Selecciona un área...",
      successAlertCreated: "¡Alerta creada con éxito!",
      errorCreatingAlert: "Error al crear la alerta",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "Y: Verifica si todas las condiciones son verdaderas. O: Verifica si al menos una de las condiciones es verdadera.",
      step1DataAndLocation: "Paso 1 - Datos y ubicación",
      step1Location: "Paso 1 - Ubicación",
      step1DataAndInsight: "Paso 1 - Datos y evento",
      step2Conditions: "Paso 2 - Condiciones",
      step2Preferences: "Paso 2 - Preferencias de entrega",
      step3Preferences: "Paso 3 - Preferencias de entrega",
      createAlert: "Crear alerta",
      dropTheFile: "Suelta el archivo aquí...",
      dragAndDrop:
        "Arrastra y suelta un archivo GeoJSON aquí, o haz clic para buscar.",
      saveArea: "Guardar área",
      areaSaved: "Área guardada",
      areaName: "Nombre del área",
      areaNamePlaceholder: "Ingresa el nombre del área",
      requiredField: "Este campo es obligatorio",
      areaSuccessOnSave: "¡Éxito! Tu área ha sido guardada",
      errorCreatingArea: "Error al crear el área",
      areaNameAlreadyExists:
        "Ya existe un área con este nombre. Por favor, elige un nombre diferente.",
      locationDataWarningTitle: "Atención a la información ingresada",
      locationDataWarningDescription:
        "Al confirmar, los datos de ubicación ingresados hasta ahora se perderán. ¿Deseas continuar?",
      yesWantToContinue: "Sí, quiero continuar",
      alertTypeChangeWarningTitle: "Atención al cambio de tipo de alerta",
      alertTypeChangeWarningDescription:
        "Al cambiar el tipo de alerta, las condiciones serán reemplazadas por las condiciones predeterminadas del nuevo tipo. ¿Deseas continuar?",
      alertTypeChangeChoiceDescription:
        "Al cambiar el tipo de alerta, las condiciones también cambian. ¿Cómo deseas continuar?",
      alertTypeChangeDescription:
        "Al cambiar el tipo de alerta, las condiciones también cambian. ¿Cómo deseas continuar?",
      keepCurrentConditions: "Mantener mis condiciones",
      useTemplateConditions: "Usar condiciones predeterminadas",
      useTypeDefault: "Usar condiciones predeterminadas",
      keepMyChanges: "Mantener mis condiciones",
      standaloneAlert: "Mi propia alerta",
      insightAlert: "Vincular a un evento",
      selectAnInsight: "Selecciona un evento",
      selectDashboard: "Tablero",
      selectDashboardPlaceholder: "Selecciona un tablero...",
      selectInsight: "Evento",
      selectInsightPlaceholder: "Selecciona un evento...",
      searchInsightPlaceholder: "Buscar evento...",
      noInsightsFound: "No se encontraron eventos",
      noInsightsInLocation: "No hay eventos en esta ubicación",
      selectedInsightConditions: "Condiciones del evento seleccionado",
      eventAction: "Acción del evento",
      eventActionTooltip:
        "Define cómo las condiciones climáticas afectan su operación. En modo Restrictivo, las condiciones limitan o impiden la operación. En modo Permisivo, las condiciones son necesarias para que la operación ocurra.",
      restrictive: "Restrictivo",
      permissive: "Permisivo",
      conditionsPreview: "Vista previa de condiciones",
      conditionPlaceholder: "La condición se mostrará aquí",
      example: "Ejemplo",
      selectInsightToSeeConditions:
        "Selecciona un evento para ver sus condiciones",
      noConditionsAvailable: "No hay condiciones disponibles",
      insightAlertTitlePrefix: "Evento",
      monitoredLocation: "Ubicación monitoreada",
      monitoredAreaPolygon: "Área monitoreada (polígono)",
      confirm: "Confirmar",
      condition: {
        and: "Y",
        or: "O",
      },
    },
    sensorAlert: {
      sectionTitle: "Alertas de sensores medidos",
      howItWorks: "Cómo funciona",
      newBadge: "Nuevo",
      // Spec 043 — Lightning support
      sensorTypeRainTab: "Lluvia",
      sensorTypeLightningTab: "Rayo",
      lightningPointPlaced: "Punto de rayo colocado",
      lightningSelectionInfo:
        "La variable de rayo funciona seleccionando un punto para monitorear.",
      lightningSelectionCallToAction:
        "Haga clic en el mapa para definir el punto de monitoreo de esta alerta.",
      lightningRadiusLabel: "Radio de monitoreo",
      lightningRadiusDescription:
        "Utilizaremos el punto seleccionado como referencia",
      lightningRadiusValue: "{{km}} km",
      clearLightningSelection: "Limpiar selección",
      lightningSilenceWindowLabel: "Ventana de silencio",
      lightningSilenceWindowHint:
        "Consideraremos el evento como finalizado después de X tiempo desde el último rayo.",
      lightningSilenceWindowOption: "{{min}} min",
      increase: "Aumentar",
      decrease: "Disminuir",
      removeRainAlert: "Remover alerta de lluvia",
      removeLightningAlert: "Remover alerta de rayo",
      removeRainAlertConfirmTitle: "¿Remover alerta de lluvia?",
      removeRainAlertConfirmDescription:
        "Perderá la selección de sensores y las condiciones configuradas para lluvia.",
      removeLightningAlertConfirmTitle: "¿Remover alerta de rayo?",
      removeLightningAlertConfirmDescription:
        "Perderá el punto de monitoreo y la configuración del rayo.",
      removeAlertConfirmButton: "Remover",
      noNearbySensorsButLightningAvailable:
        "No hay sensores cerca de su ubicación, pero aún puede configurar una alerta de rayo.",
      tipoColumn: "Tipo",
      chuvaLabel: "Lluvia",
      raioLabel: "Rayo",
      LIGHTNING_RADIUS_OUT_OF_RANGE:
        "El radio de monitoreo debe estar entre 1 y 100 km.",
      LIGHTNING_ALL_CLEAR_INVALID:
        "Ventana de silencio inválida. Valores aceptados: 1, 5, 10, 30 o 60 min.",
      LIGHTNING_NOTIFICATION_INVALID:
        "Frecuencia de alerta inválida.",
      LIGHTNING_POINT_INVALID:
        "Coordenadas del punto de rayo inválidas.",
      LIGHTNING_ANCHOR_INVALID:
        "Ancla de estación inválida en la alerta de rayo.",
      howItWorksExampleTitle: "Ejemplo de mensaje:",
      howItWorksExampleLine1: "Alerta de Sensor de lluvia",
      howItWorksExampleLine2Bold: "Mayor acumulado (24h): 35,3 mm",
      howItWorksExampleLine2Rest: " en el sensor <nombre sensor>",
      howItWorksExampleLine3Label: "Lectura de los sensores:",
      howItWorksExampleLine3Item1:
        " • 2 de 4 sensores activos registraron lluvia acumulada > 20 mm (24h)",
      howItWorksExampleLine3Item2: " • 1 sensor inoperativo",
      howItWorksExampleLine4: "Alerta configurada en el evento:",
      howItWorksExampleLine5: "Inundación en la vía del tranvía en <localidad>",
      howItWorksTooltip:
        "Las alertas de sensores medidos le notifican cuando los datos en tiempo real de sensores físicos superan las condiciones configuradas. A diferencia de las alertas de pronóstico, estas se activan por valores medidos reales.",
      sensorsAvailable: "{{count}} sensores disponibles",
      sensorsAvailable_one: "{{count}} sensor disponible",
      suggestionText: "{{count}} sensores - radio de 30km",
      suggestionText_one: "{{count}} sensor - radio de 30km",
      suggestionFoundDescription:
        "Se encontraron <b>{{count}}</b> sensores cerca de su ubicación.",
      suggestionFoundDescription_one:
        "Se encontró <b>{{count}}</b> sensor cerca de su ubicación.",
      suggestionCardSubtitle: "{{count}} en un radio de {{radius}}km",
      suggestionCardSubtitle_one: "{{count}} en un radio de {{radius}}km",
      viewNearbySensors: "Ver sensores cercanos",
      createMyOwnWay: "Crear a mi manera",
      disableAlert: "Deshabilitar alerta",
      viewMessage: "Ver mensaje",
      selectedSensors: "{{count}} sensores seleccionados",
      selectedSensors_one: "{{count}} sensor seleccionado",
      emptyStateTitle: "Sin sensores cerca de la ubicación seleccionada",
      emptyStateDescription:
        "No hay sensores de precipitación disponibles en esta región.",
      errorLoadingSensors:
        "Error al cargar sensores. Por favor, inténtelo de nuevo.",
      errorLoadingSensorEnvironmentalVariables:
        "Error al cargar las variables ambientales. Por favor, inténtelo de nuevo.",
      retry: "Intentar de nuevo",
      disableAlertModalTitle: "Deshabilitar alerta de sensor",
      disableAlertModalDescription:
        "¿Está seguro de que desea deshabilitar la alerta de sensor? Los sensores seleccionados y las condiciones serán eliminados.",
      disableAlertConfirm: "Deshabilitar",
      disableAlertCancel: "Cancelar",
      closeAriaLabel: "Cerrar",
      step3DisableModalTitle: "Aviso de cambio en las condiciones",
      step3DisableModalDescription:
        "Actualmente los datos de sensor están habilitados solo en el evento con alerta. Al desactivar la alerta, dejará de recibir estas actualizaciones. ¿Desea continuar?",
      step3DisableConfirm: "Desactivar datos de sensor",
      step3DisableCancel: "Volver",
      sensorConditionsEmptyStateTitle:
        "Agrega una condición para activar la alerta de sensor",
      sensorConditionsEmptyStateCreateButton: "Crear condición",
      singleSensorWarning:
        "Para un mejor monitoreo en el área de su alerta, recomendamos seleccionar más de 1 sensor.",
      sensorSelectionTitle: "Seleccione los sensores de precipitación",
      sensorSelectionDescription:
        "Haga clic en los sensores para seleccionar o deseleccionar.",
      sensorSuggestionReviewDescription:
        "Estos sensores fueron sugeridos basándose en el radio de 30km. Puede ajustar la selección.",
      sensorSelectionTitleMulti: "Selección de sensores",
      sensorSelectionSubtitleMulti:
        "Sensores de cada variable que desea utilizar para el evento:",
      concludeConfiguration: "Finalizar configuración",
      confirmSelection: "Confirmar",
      backToEvent: "Volver",
      noSuggestionFound:
        "No se encontraron sensores en la ubicación seleccionada,",
      createAlertOutsideLocation:
        "¿desea crear una alerta con un sensor fuera de la ubicación?",
      createAlert: "Crear alerta",
      includeTitle: "¿Incluir alerta de dato medido?",
      viewSelectedSensorsTooltip: "Sensores seleccionados:",
      editSensors: "Editar selección de sensores",
      editSelection: "Editar selección",
      howItWorksModalTitle: "Alerta adicional de sensor",
      howItWorksBody1:
        "Al configurar un evento, puede ir más allá de las condiciones de pronóstico e incluir también una alerta de datos de sensores en tiempo real.",
      howItWorksBody2Normal: "Al activar esta opción, recibirá",
      howItWorksBody2Bold:
        "alertas separadas, una de pronóstico y otra de sensor.",
      periodicityLabel: "Periodicidad de la alerta",
      periodicityRecurring: "Recurrente",
      periodicitySingle: "Único",
      frequencyLabel: "Reciba actualizaciones cada",
      frequencyHour_one: "{{count}} hora",
      frequencyHour: "{{count}} horas",
      recurringDescription:
        "Reciba actualizaciones periódicas del sensor en el intervalo definido, independientemente de cambios",
      singleDescription:
        "Reciba una alerta cuando el valor supere el límite y otra cuando vuelva a la normalidad.",
      recurringTooltipTitle: "Envío Recurrente",
      recurringTooltip:
        "Reciba actualizaciones periódicas del sensor en el intervalo definido, independientemente de cambios",
      singleTooltipTitle: "Envío Único",
      singleTooltip:
        "Reciba una alerta cuando el valor supere el límite y otra cuando vuelva a la normalidad.",
      templateModalTitle: "Ver mensaje",
      templateExampleLabel: "Ejemplo de mensaje",
      templateAlertTitle: "Alerta de Sensor de lluvia",
      templateMainReading:
        "Mayor acumulado (24h): 35,3 mm en el sensor {{sensorName}}",
      templateSensorReadingsTitle: "Lectura de sensores:",
      templateSensorReadingsBullet:
        "{{activeSensors}} de {{totalSensors}} sensores activos registraron {{condition}}",
      templateSensorReadingsExample:
        "Sensores activos registraron lluvia acumulada > 20 mm (24h)",
      templateInoperantSensors: "Sensores inoperantes: 1",
      templateEventLabel: "Alerta configurada en el evento:",
      templateLocationPreposition: "en",
      templateExampleSensorName: "Sensor Ejemplo",
      templateExampleEventName: "Nombre del evento",
      templateExampleLocation: "Localidad",
      gotIt: "Entendido",
      pleaseAddSensorCondition:
        "* Por favor, agrega al menos una condición para la alerta de sensor.",
    },
    operationRule: {
      createDashboard: "Crear un nuevo tablero",
      youNeed4AlphaNumericToTheKey:
        "¡Ups! Necesitas usar 4 caracteres alfanuméricos para la clave. ej: ABCD, ABC1, A1BC",
      informNameAndKeyForAdd:
        "Informa el nombre y la clave para agregar un nuevo tablero.",
      informNameAndKeyForEdit: "Informa el nombre y la clave para editar.",
      removalFailedContactUs: "Error en la eliminación. Contáctanos",
      diveIntoEditDashboard: "Accede al panel de edición.",
      operationInsight: "Eventos operativos",
      dashboard: "Tablero",
      name: "Nombre",
      key: "Clave",
      pleaseInformNameOfDashboard: "Por favor, informa el nombre del tablero.",
      informDashboardName: "Informa el nombre del tablero",
      pleaseInformKeyOfDashboard: "Por favor, informa la clave del tablero.",
      add: "Agregar",
      newNameDashboard: "Nuevo nombre del tablero",
      newKey: "Nueva clave",
      save: "Guardar",
      cancel: "Cancelar",
      edit: "Editar",
      areYouSureWantDeleteDashaboard:
        "¿Estás seguro de que deseas eliminar este tablero?",
      delete: "Eliminar",
      videoTutorials: "Tutoriales en video",
      errorToGetData: "Error al obtener datos. Por favor contáctanos.",
      errorToAddData: "Error al agregar datos. Por favor contáctanos.",
      needToInformIdForUpdateData:
        "Necesitas informar el ID para actualizar los datos",
      errorToUpdateData: "Error al actualizar datos. Por favor contáctanos.",
      needInformIdForDeleteData:
        "Necesitas informar el ID para eliminar los datos",
      errorToDeleteData: "Error al eliminar datos. Por favor contáctanos.",
      yes: "Sí",
      no: "No",
      startCreatingFirstInsight:
        "Comienza a crear tu primer evento agregando un tablero",
      editDashboard: "Editar tablero",
      deleteDashboard: "Eliminar tablero",
      areYouSureCantUndoThis:
        "¿Estás seguro? ¡{{dashboardName}} será eliminado!",
      newDashboard: "Nuevo tablero",
      search: "Buscar",
      dashboardSuccessOnSave: "¡Éxito! Tu tablero ha sido guardado",
    },
    operationRuleLocation: {
      youNeedSelectDashboardToAddLocation:
        "¡Ups! Necesitas seleccionar un tablero para agregar una ubicación",
      locationRemovalFailedContactUs:
        "Error al eliminar la ubicación. Contáctanos",
      editLocation: "Editar ubicación",
      operationInsight: "Eventos operativos",
      location: "Ubicación",
      diveEditDashboard: "accederAlPanelDeEdición",
      selectDashboard: "Selecciona un tablero",
      addNewLocation: "Agregar nueva ubicación",
      edit: "Editar",
      areYouSureWantDeleteLocation:
        "¿Estás seguro de que deseas eliminar esta ubicación?",
      yes: "Sí",
      no: "No",
      delete: "Eliminar",
      videoTutorials: "Tutoriales en video",
      add: "Agregar",
      cancel: "Cancelar",
      youNeed4AlphaNumericToTheKey:
        "¡Ups! Necesitas usar 4 caracteres alfanuméricos para la clave. ej: ABCD, ABC1, A1BC",
      name: "Nombre",
      pleaseInputLocationName: "¡Por favor, ingresa el nombre de la ubicación!",
      key: "Clave",
      pleaseInputInitialNameLocation:
        "¡Por favor, ingresa el nombre inicial de la ubicación!",
      inputLocationSummary: "Por favor, ingresa el resumen de la ubicación",
      region: "Región",
      pleaseSelectRegionFromList: "Selecciona una región",
      station: "Estación",
      pleaseSelectStationFromList: "Selecciona una estación",
      errorGetLocationData:
        "Error al obtener datos de ubicación. Por favor contáctanos.",
      errorAddLocationData:
        "Error al agregar datos de ubicación. Por favor contáctanos.",
      errorUpdateLocationData:
        "Error al actualizar datos de ubicación. Por favor contáctanos.",
      errorDeleteLocationData:
        "Error al eliminar datos. Por favor contáctanos.",
      summary: "Resumen",
      addNewLocationToYourDashboard: "Agrega una nueva ubicación a tu tablero.",
      deleteLocation: "Eliminar ubicación",
      areYouSureCantUndoThis:
        "¿Estás seguro? ¡{{locationName}} será eliminada!",
      save: "Guardar",
      youNeedToFillAllTheFields: "Necesitas completar todos los campos",
      locationSuccessOnSave: "¡Éxito! Tu ubicación ha sido guardada",
      stationNotFoundPleaseSelectValidStation:
        "Estación no encontrada. Por favor, selecciona una estación válida",
      point: "Punto",
      pointDescription:
        "Ideal para monitorear eventos en una ubicación específica.",
      area: "Área",
      areaDescription:
        "Ideal para monitorear eventos alrededor de tu ubicación de interés.",
      locationType: "Tipo de ubicación",
      monitoredLocation: "Ubicación monitoreada",
      pointDetails: "Detalles del punto",
      back: "Atrás",
      monitoredArea: "Área monitoreada",
      drawArea: "Dibujar un área",
      selectSavedArea: "Seleccionar área guardada",
      importGeojson: "Importar GeoJSON",
      pleaseDrawAnArea:
        "* Por favor, dibuja un área en el mapa o importa una existente.",
      selectAreaPlaceholder: "Selecciona un área...",
      thisFieldRequired: "Este campo es obligatorio",
      selectAreaAboveToVisualize: "Selecciona el área arriba para visualizar.",
      dragAndDrop:
        "Arrastra y suelta un archivo GeoJSON aquí, o haz clic para buscar.",
      dropTheFile: "Suelta el archivo aquí...",
      saveArea: "Guardar área",
      areaSaved: "Área guardada",
      clear: "Limpiar",
      invalidArea:
        "Asegúrate de que el polígono esté ubicado cerca de tus estaciones registradas.",
      confirmLocationTypeChange: "Edición de evento de área",
      areaEventEditing: "Edición de evento de área",
      changePointToAreaWarning:
        "Al confirmar, este evento tardará unos minutos en volver a mostrarse en la Información Operativa, ¿deseas continuar?",
      yesIWantToContinue: "Sí, quiero continuar",
    },
    operationRuleLocationInsight: {
      youNeedSelectLocationToEditInsight:
        "¡Ups! Necesitas seleccionar una ubicación para editar un evento",
      locationRemovalFailedContactUs:
        "Error al eliminar la ubicación. Contáctanos",
      youNeedSelectLocationToAddInsight:
        "¡Ups! Necesitas seleccionar una ubicación para agregar un nuevo evento",
      editInsight: "Editar evento",
      operationInsight: "Eventos operativos",
      insight: "Evento",
      diveEditDashboard: "Accede al panel de edición.",
      selectLocation: "Selecciona una ubicación",
      addNewInsight: "Agregar nuevo evento",
      edit: "Editar",
      areYouSureWantDeleteInsight:
        "¿Estás seguro de que deseas eliminar este evento?",
      delete: "Eliminar",
      videoTutorials: "Tutoriales en video",
      informGroupConditionInsight:
        "¡Ups! Informa un grupo de condiciones de este evento.",
      informConditionGroupsInsight:
        "¡Ups! Informa una condición en los grupos de este evento.",
      errorCriticalUpdateGroupConditions:
        "Error crítico al actualizar las condiciones del grupo. Por favor, ¡contáctanos!",
      add: "Agregar",
      name: "Nombre",
      restrictionType: "Restrictivo",
      noRestrictionType: "Permisivo",
      insightType: "Tipo de evento",
      tooltipRestrictionType:
        "Elige el tipo de evento según las condiciones del evento: restrictivo o permisivo.",
      pleaseInputInsightName: "¡Por favor, ingresa el nombre del evento!",
      stopNavigationForSmallBoats:
        "Detener navegación para embarcaciones pequeñas",
      high: "Alta",
      medium: "Media",
      low: "Baja",
      pleaseEnterSummary: "Por favor, ingresa un resumen",
      theNavigationShouldStoppedWindsTooStrong:
        "La navegación debe detenerse porque los vientos son demasiado fuertes",
      conditions: "Condiciones",
      conditionsInsideConditionGroupShouldHaveSameLogicalOperator:
        "Las condiciones dentro del grupo de condiciones deben tener el mismo operador lógico. Si deseas diferentes operadores lógicos, por favor agrega otro grupo",
      pleaseSelectEnvironmentalVariable:
        "Por favor, selecciona una variable ambiental",
      isGreaterThan: "es mayor que",
      isEqualToOrGreaterThan: "es igual o mayor que",
      isEqualTo: "es igual a",
      isLessThan: "es menor que",
      isEqualToOrLessThan: "es igual o menor que",
      pleaseEnterValue: "¡Por favor, ingresa el valor!",
      addNewCondition: "Nueva condición",
      removeGroup: "Eliminar grupo",
      addNewGroup: "Nuevo grupo",
      errorWhileGetDataForInsights:
        "Error al intentar obtener datos para eventos. Por favor contáctanos.",
      errorWhileAddInsight:
        "Error al intentar agregar evento. Por favor contáctanos.",
      internalErrorToUpdateData:
        "Error interno al actualizar datos. Por favor contáctanos.",
      errorDeleteInsight: "Error al eliminar el evento. Por favor contáctanos.",
      yes: "Sí",
      no: "No",
      cancel: "Cancelar",
      error: "Error",
      insightsProcessing:
        "Los eventos de área necesitan tiempo para ser procesados. Una vez completados, serás notificado aquí y por correo electrónico.",
      details: "Detalles",
      priority: "Prioridad",
      summary: "Resumen",
      location: "Ubicación",
      and: "Y",
      or: "O",
      weReAlmostTheNowRegisterInsight:
        "¡Casi estamos! Ahora solo necesitas registrar tu primer evento",
      areYouSureCantUndoThis: "¿Estás seguro? ¡{{insightName}} será eliminado!",
      save: "Guardar",
      deleteInsight: "Eliminar evento",
      group: "Grupo",
      type: "Tipo",
      youNeedToFillAllTheFields:
        "Necesitas completar todos los campos obligatorios",
      addNewConditionGroupInsight:
        "Agrega un nuevo grupo de condiciones climáticas para crear tu evento",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "Y: Verifica si todas las condiciones son verdaderas. O: Verifica si al menos una de las condiciones es verdadera.",
      groupsAreConditionsAddOneConditions:
        "Los grupos son conjuntos de condiciones climáticas. Agrega al menos una condición climática para cada grupo creado",
      nameRequired: "El nombre es obligatorio",
      summaryRequired: "El resumen es obligatorio",
      valueRequired: "El valor es obligatorio",
      insightSuccessOnSave: "¡Éxito! Tu evento ha sido guardado",
      deleteGroup: "Eliminar grupo",
      areYouSureWantDeleteGroup:
        "¿Estás seguro de que deseas eliminar este grupo?",
      windAndGustProbabilities:
        "Las probabilidades de viento y ráfagas estarán disponibles después de la próxima actualización del pronóstico.",
      continue: "Continuar",
      back: "Atrás",
      gotIt: "Entendido",

      operationImpactSeverity: "Severidad del impacto en tu operación",
      whatIsAndHowItWorks: "¿Qué es y cómo funciona?",
      example: "Ejemplo",
      containerDropRiskInsight:
        "Un riesgo puede clasificarse como alto incluso si es raro, como en el caso de la caída de un contenedor, donde la severidad es extrema debido a su potencial para comprometer la seguridad de los involucrados en la operación.",
      informSeverityBasedOnImpact:
        "Informa la severidad según el impacto que este evento tiene en tu operación.",
      selectSeverity: "Selecciona la severidad",
      noImpact: "Sin impacto",
      minor: "Menor",
      moderate: "Moderado",
      major: "Mayor",
      severe: "Severo",
      insightSeverity: "Visualización de riesgo en eventos",
      riskMatrixDescription:
        "La matriz de riesgo cruza la probabilidad de un evento con la severidad del impacto que puede causar. i4cast destaca los riesgos más importantes en color, ayudándote a actuar con enfoque.",
      severityRequired: "La severidad es obligatoria",
      color: "Color",
      colorOnDashboard: "Color en el panel",
      blue: "Azul",
      orange: "Naranja",
      yellow: "Amarillo",
      red: "Rojo",
      registeredAlerts: "Alertas registradas",
      oneAlert: "1 alerta",
      multipleAlerts: "alertas",
    },
    insightManager: {
      insightManager: "Gestor de eventos",
      dashboards: "Tableros",
      locations: "Ubicaciones",
      insights: "Eventos",
    },
  },
  registerUser: {
    errorWhileLoadUserAreaOptions:
      "Error al cargar las opciones de área del usuario",
    youHaveSuccessfullyRegistered:
      "¡Hurra! Te has registrado con éxito y ahora puedes iniciar sesión.",
    errorWhileRegisterUser: "Error al registrar usuario",
    expiredInvitation: "Invitación expirada",
    sorryThePageYouVisitedNotExist:
      "Lo sentimos, la página que visitaste no existe.",
    youInvitedJoinI4cast: "¡Has sido invitado a unirte a i4cast®!",
    invitedBy: "Invitado por",
    name: "Nombre",
    pleaseInputYourName: "Por favor, ingresa tu nombre",
    nameMustContainOnlyLetters: "El nombre debe contener solo letras",
    lastName: "Apellido",
    pleaseInputYourLastName: "Por favor, ingresa tu apellido",
    lastNameMustContainOnlyLetters: "El apellido debe contener solo letras",
    username: "Nombre de usuario",
    pleaseInputYourUsername: "¡Por favor, ingresa tu nombre de usuario!",
    lastNameMustStartWithLetter:
      "Debe comenzar con una letra, contener solo caracteres alfanuméricos, '_' y '.'",
    usernameAlreadyHasAccount:
      "El nombre de usuario ya tiene una cuenta de i4cast",
    password: "Contraseña",
    pleaseInputPassword: "¡Por favor, ingresa tu contraseña!",
    passwordMustContain: "Debe contener al menos 6 dígitos y una letra",
    phone: "Teléfono",
    jobArea: "Área de trabajo",
    jobPosition: "Cargo",
    register: "Registrarse",
    errorInInvitation: "Error en la invitación",
  },
  settings: {
    unitMeasurement: "Unidad de medida",
    success: "¡Éxito!",
    yourChangesHaveSaved: "Tus cambios han sido guardados.",
    changingUnitStillNotAppliedOperationInsights:
      "¡El cambio de unidades aún no se aplica a los Eventos Operativos!",
    wind: "VIENTO",
    knots: "nudos",
    ms: "m/s",
    mph: "mph",
    kmh: "km/h",
    current: "CORRIENTE",
    wave: "OLA",
    m: "m",
    km: "km",
    ft: "ft",
    waterLevel: "NIVEL DEL AGUA",
    cm: "cm",
    precipitation: "PRECIPITACIÓN",
    mm: "mm",
    inches: "pulgadas",
    settings: "Configuración",
    selectHowYouWantToSee: "Selecciona cómo quieres ver",
    visibility: "Visibilidad",
    adjustYouPreferences:
      "Ajusta tus preferencias en i4cast—cualquier cambio que hagas tendrá efecto inmediatamente.",
    timezone: "Zona horaria",
  },
  admin: {
    changePassword: {
      passwordNotMatch: "Las contraseñas no coinciden",
      successChangedPassword: "¡Éxito! Has cambiado tu contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirmar nueva contraseña",
      updatePassword: "Actualizar contraseña",
    },
    myData: {
      pleaseInformPhoneNumber: "Por favor, informa tu número de teléfono.",
      dataEditedSuccess: "Datos editados con éxito",
      myData: "Mis datos",
      name: "Nombre",
      pleaseInputYourName: "¡Por favor, ingresa tu nombre!",
      middleName: "Segundo nombre",
      lastName: "Apellido",
      pleaseInputYourLastName: "¡Por favor, ingresa tu apellido!",
      changePassword: "Cambiar contraseña",
      email: "Correo electrónico",
      pleaseInputYourEmail: "¡Por favor, ingresa tu correo electrónico!",
      selectYourJobPosition: "Selecciona tu cargo",
      pleaseSelectJobPosition: "¡Por favor, selecciona tu cargo de la lista!",
      selectYourJobArea: "Selecciona tu área de trabajo",
      pleaseSelectJobArea:
        "¡Por favor, selecciona tu área de trabajo de la lista!",
      edit: "Editar",
      portuguese: "Portugués",
      english: "Inglés",
      errorGetUserData:
        "Error al obtener datos del usuario. Por favor contáctanos.",
      errorUpdateUserData:
        "Error al actualizar datos del usuario. Por favor contáctanos.",
      errorGetUserPositionData:
        "Error al obtener datos del cargo del usuario. Por favor contáctanos.",
      errorGetUserAreaData:
        "Error al obtener datos del área del usuario. Por favor contáctanos.",
      success: "Éxito",
      errorUpdateUserLanguage:
        "Error al actualizar el idioma del usuario. Por favor contáctanos.",
      error: "Error",
      phone: "Teléfono",
      pleaseEnterValidPhone: "Por favor, ingresa un número de teléfono válido",
      updatePhoneNumber: "Actualizar número de teléfono",
      enterYourNewPhone: "Ingresa tu nuevo número de teléfono",
      sendVerificationCode: "Enviar código de verificación",
      updateNumber: "Actualizar número",
      verifiedNumber: "Número verificado",
      numberNotVerified: "Número no verificado",
      phoneSuccessfullyUpdated:
        "¡Éxito! Tu número de teléfono ha sido guardado.",
      iAgreeReceive:
        "Acepto recibir alertas vía WhatsApp sobre condiciones de riesgo.",
      phoneAlreadyInUse: "Este número de teléfono ya está en uso.",
      alreadyVerifiedNumber: "Número ya verificado",
      verifyPhoneToReceiveAlerts:
        "¡Creaste una alerta! Para recibir notificaciones de WhatsApp, necesitas verificar tu número de teléfono.",
    },
    userManager: {
      yourInviteSuccessfullySent:
        "¡Hurra! Tu invitación fue enviada con éxito y un nuevo usuario llegará pronto.",
      errorWhileSendInvitation:
        "Error al intentar enviar la invitación. Por favor contáctanos.",
      userPermissionGroupSuccessfully:
        "Grupo de permisos de usuario aplicado con éxito",
      errorWhileEditUser:
        "Error al intentar editar usuario. Por favor contáctanos.",
      userDataNotFoundOnList:
        "Datos del usuario no encontrados en la lista. Por favor contáctanos.",
      userDeactivatedSuccessfully: "Usuario desactivado con éxito",
      userReactivatedSuccessfully: "Usuario reactivado con éxito",
      errorWhileDeactivateUser:
        "Error al intentar desactivar usuario. Por favor contáctanos.",
      errorWhileReactivateUser:
        "Error al intentar reactivar usuario. Por favor contáctanos.",
      userManager: "Gestor de usuarios",
      inviteUser: "Invitar usuario",
      inviteNewUserFromOrganization:
        "¡Invita a un nuevo usuario de tu organización a unirse a i4cast®!",
      invite: "Invitar",
      thisIsStillNotValidEmail: "¡Este aún no es un correo electrónico válido!",
      pleaseInputYourEmail: "¡Por favor, ingresa tu correo electrónico!",
      emailAlreadyHasi4cast:
        "El correo electrónico ya tiene una cuenta de i4cast",
      userGroup: "Grupo de usuario",
      admin: "Admin",
      hasPermissionManageInviteUsers:
        "Tiene permiso para gestionar e invitar nuevos usuarios.",
      basic: "Básico",
      canAccessEditAllFeatures:
        "Puede acceder y editar todas las funciones de i4cast.",
      pleaseInput: "Por favor ingresa",
      granted: "Concedido",
      denied: "Denegado",
      name: "Nombre",
      username: "Nombre de usuario",
      email: "Correo electrónico",
      permissionGroup: "Grupo de permisos",
      accessToI4cast: "Acceso a i4cast®",
      areYouSureWantDeactivateUser:
        "¿Estás seguro de que deseas desactivar este usuario?",
      areYouSureWantreactivateUser:
        "¿Estás seguro de que deseas reactivar este usuario?",
      yes: "Sí",
      no: "No",
      deactivate: "Desactivar",
      reactivate: "Reactivar",
      ok: "Ok",
      reset: "Restablecer",
      invalidUserGroup: "Grupo de usuario inválido",
      expiredInvitation: "Invitación expirada",
      invitedAlreadyUsed: "Invitación ya utilizada",
      thisEmailAlreadyInvited: "Este correo electrónico ya ha sido invitado",
      thisEmailAlreadyUse: "Este correo electrónico ya está en uso",
      invitationNotFound: "Invitación no encontrada",
      readOnly: "Solo lectura",
      allowVisualizeData:
        "Permite visualizar datos e información sin la capacidad de modificarlos.",
    },
  },
  analytics: {
    waterLevel: "Nivel del agua",
    weather: "Clima",
    current: "Corriente",
    wind: "Viento",
    wave: "Ola",
    selectRegion: "Selecciona una región",
    selectStation: "Selecciona una estación",
    sensorDataNotAvailable:
      "Lo sentimos, pero los datos del sensor para esta estación no están disponibles.",
    errorGetSensorData:
      "Error al intentar obtener datos para el gráfico de mediciones. Por favor contáctanos.",
    sensorData: "Datos del sensor",
    errorToTryGetDataStationOnAnalytics:
      "Error al intentar obtener datos de la estación en el tipo de gráfico de análisis de mediciones. Por favor contáctanos.",
    sorryButNoSensorsAreAvailableforData:
      "Lo sentimos, pero no hay sensores disponibles para este tipo de datos.",
  },
  atmOcean: {
    clickToGoBackPastForecasts: "Haz clic para volver a pronósticos pasados",
    youNeedSelectStationToExport:
      "¡Ups! Necesitas seleccionar una estación para exportar los datos.",
    waterFlow: "Flujo de agua",
    waveSea: "Ola de mar",
    waveSwell: "Ola de oleaje",
    selectStation: "Selecciona una estación",
    exportCsv: "Exportar .csv",
    time: "Hora",
  },
  dynamicUKC: {
    dynamicClearanceNotAvailable:
      "Los cálculos de calado dinámico bajo quilla no están disponibles para tu empresa. ¿Te gustaría solicitar esta funcionalidad?",
    gotIt: "¡Entendido!",
    skip: "omitir",
    settings: "Configuración",
    ukcRestriction: "RESTRICCIÓN UKC",
    meters: "Metros",
    close: "Cerrar",
    save: "Guardar",
    station: "Estación",
    travelCode: "Código de viaje",
    dynamicUkcDocking: "UKC dinámico - Atraque",
    maneuverDraft: "Calado de maniobra",
    dynamicUkc: "UKC dinámico",
    ukcRestrictionLower: "Restricción UKC",
    dynamicUkcUndocking: "UKC dinámico - Desatraque",
    selectShip: "Selecciona un barco",
    alert: "Alerta",
    clickToBeRedirected:
      "Haz clic abajo para ser redirigido a las FAQ de UKC dinámico",
    gotToDynamicUkc: "Ir a UKC dinámico",
  },
  forecastChart: {
    forecastChartFormStation: {
      informStationDescription: "Informa una descripción de la estación.",
      failedGetVirtualStationGeolocation:
        "Error al obtener la geolocalización de la estación virtual. Por favor contáctanos.",
      youAreOutOfRegionArea: "¡Ups! Estás fuera del área de la región.",
      stationDescription: "Descripción de la estación",
      save: "Guardar",
      doYouWantSaveStation: "¿Deseas guardar la estación?",
      saveStation: "Guardar estación",
      areYouSureWantDeleteStation:
        "¿Estás seguro de que deseas eliminar esta estación?",
      yes: "Sí",
      no: "No",
      requiredField: "Campo obligatorio",
      invalidLatLng: "Latitud y longitud inválidas",
      searchCoordsLatLng: "Buscar coordenadas (latitud y longitud)",
      cancel: "Cancelar",
      search: "Buscar",
      searchCoord: "Buscar coordenadas",
      removeStation: "Eliminar estación",
      unauthorizedUser:
        "¡Ups! Parece que no tienes permiso para eliminar esta estación. Por favor, ponte en contacto con el administrador del sistema",
      youOnlyHaveReadPermission: "Solo tienes permiso de lectura",
    },
    forecastChartPage: {
      youAreOutOfRegionArea: "¡Ups! Estás fuera de tu área de región.",
      thereIsAlreadyStationName: "Ya existe una estación con este nombre:",
      errorToSaveVirtualStation:
        "Error al guardar la estación virtual. Por favor contáctanos.",
      successSationHasSaved: "¡Éxito! La estación ha sido guardada",
      errorToRemoveStation:
        "Error al eliminar la estación. Por favor contáctanos.",
      station: "Estación:",
      errorToGetDataStationMeteogramChartType:
        "Error al intentar obtener datos de la estación en el tipo de gráfico de meteograma. Por favor contáctanos.",
      errorToGetDataValidStationMeteogramChartType:
        "Error al intentar obtener datos de estación válida en el tipo de gráfico de meteograma. Por favor contáctanos.",
      stationWithInsight: "Estación con evento",
      clickBlueMarkersInTheMap:
        "Haz clic en los marcadores azules del mapa si deseas",
      toDisplayForecastChartWaveSpectra:
        " mostrar gráficos de pronóstico con tipo de datos de espectro de olas ",
      letsGo: "Vamos",
      newEraForForecast: "Una nueva era para los pronósticos",
      geospatialInsight: "Evento geoespacial",
      exploreGeospatialInsights:
        "Explora eventos geoespaciales para comprender las condiciones climáticas en tu región. Toma decisiones con una vista completa de las condiciones climáticas en áreas estratégicas para optimizar tus operaciones y planificación.",
      minimizeRisks: "Minimiza riesgos",
      analysingPoints: "analizando puntos a tu alrededor",
      customAnalysis:
        "Personalización del análisis: Personaliza tus análisis climáticos según los eventos seleccionados",
      newEraGeospatial: "Una nueva era geoespacial",
      inI4castPush: "en i4cast impulsa la toma de decisiones estratégicas.",
      insightForAllStations: "Evento para todas las estaciones",
      chooseInsight:
        "Elige un evento y navega entre estaciones para visualizarlo.",
      insightType: "Tipos de evento",
      nowToCreateAnInsight:
        "Ahora, cuando creas un evento, puedes categorizarlo como 'Permisivo' o 'Restrictivo'. Esto significa que cuando selecciones un evento en la pantalla de gráficos de pronóstico, se representará según la categoría elegida de la siguiente manera:",
      permissive: "Permisivo",
      noEvent: "Sin evento",
      warning: "Atención",
      withEvent: "Con evento",
      restrictive: "Restrictivo",
      gotIt: "Entendido",
      back: "Atrás",
      next: "Siguiente",
      skip: "Omitir",
      last: "Cerrar",
      createAlert: "Crear alerta",
      sensorForecastData:
        "Esta estación no tiene sensor. Mostrando datos de pronóstico.",
      noSensorWasFound: "No se encontró ningún sensor para esta región",
    },
    forecastChartPanelHeader: {
      noData: "¡No se encontró ningún evento!",
      enterAtLeastThreeLetters: "Ingresa al menos 3 letras",
      enterYourInsight: "Ingresa tu evento aquí",
      showInsightInForecastCharts: "Mostrar evento en gráficos de pronóstico",
      insightWithoutData: "Estaciones sin datos",
      theGrayIconIndicates:
        "El ícono gris indica falta de datos para el evento seleccionado",
      thereIsNoInsightDataAvailable:
        "No hay datos de evento disponibles para esta estación",
      noEventsForThisStation: "No hay eventos previstos para esta estación",
      markAsFavorite: "¡Marca como favorito para acceso rápido!",
      insightFavoriteSuccessOnSave:
        "¡Éxito! Tu evento ha sido marcado como favorito",
      opsErrorMarkingInsightAsFavorite:
        "¡Ups! Error al marcar el evento como favorito",
      insightFavoriteSuccessOnDelete:
        "¡Éxito! Tu evento ha sido desmarcado como favorito",
      opsErrorOnRemoveInsightAsFavorite:
        "¡Ups! Error al eliminar el evento como favorito",
      removeFavorite: "Eliminar favorito",
      selectStation:
        "¡Ups! Por favor, selecciona una estación para mostrar el evento!",
      selectInsightToEnable:
        "Selecciona un evento para habilitar esta visualización.",
      loading: "Cargando",
    },
    forecastChartInsightTimeline: {
      swapToSetRanges:
        "Desliza para establecer rangos en los círculos exteriores.",
      useTheCursorToAdjustTime:
        "Usa el cursor para ajustar los rangos de tiempo en el círculo exterior. Arrastra para establecer nuevos períodos.",
    },
    forecastChartInsightLegend: {
      realTimeForecast: "Pronóstico en tiempo real",
      forecastTimeline: "Rango de línea de tiempo",
      innerCircle: "Círculo interior",
      outerCircle: "Círculo exterior",
    },
    forecastChartPanelEnvironmentalButtons: {
      weather: "Clima",
      wave: "Olas",
      visibility: "Visibilidad",
      waveHeight: "Altura de ola",
      waveHeightMax: "Altura máx. de ola",
      wavePeakPeriod: "Período pico",
      waveMeanPeriod: "Período medio",
      waterFlow: "Flujo de agua",
      stationWithInsight: "Estación con evento",
      wind: "Viento",
      wind10m: "Viento 10m",
      wind50m: "Viento 50m",
      wind100m: "Viento 100m",
      gust10m: "Ráfaga 10m",
      gust50m: "Ráfaga 50m",
      gust100m: "Ráfaga 100m",
      temperature: "Temperatura",
      waveTotal: "Ola",
      waveSea: "Mar",
      waveSwell: "Oleaje",
      rain: "Lluvia",
      accumulatedRain: "Lluvia acumulada",
    },
    forecastChartPanelMap: {
      searchLocationOrLatLon: "buscar ubicación o lat, lon",
      exactLocation: "Ubicación exacta",
      insightDataUpdate: "Marcadores geoespaciales reiniciados.",
      insightDataUpdateDescription:
        "Último cálculo de evento hace 15 minutos para esta región. Datos actualizados en el área seleccionada.",
      searchAddress: "Buscar dirección",
      noInsightData: "sin datos de evento",
      sensorDataIsDelayed: "Los datos del sensor están retrasados.",
      loading: "Cargando",
      noRadarDataAvailable: "No hay datos de radar disponibles.",
    },
    forecastChartPanelMeteogram: {
      all: "Todo",
      dataInterval: "Intervalo de datos",
      refreshToseeNewData: "Actualiza para ver nuevos datos disponibles",
      thereIsnotDataAvailable:
        "¡Ups! No hay datos de {{empty}} {{location}} {{empty2}} disponibles en esta ubicación.",
      thereIsnotProbabilisticDataAvailable:
        "¡Ups! No hay datos probabilísticos de {{empty}} {{location}} {{empty2}} disponibles en esta ubicación.",
      thereIsnotSensorDataAvailable:
        "¡Ups! No hay datos medidos de {{empty}} {{location}} {{empty2}} disponibles en esta ubicación.",
      somethingWrong: "¡Ups! Algo salió mal.",
      lastUpdatedAt: "Última actualización a las",
      delayedSensor: "Los datos del sensor están",
      nextUpdateEstimatedAt: "Próxima actualización estimada a las",
      aboutForecast: "Sobre los pronósticos",
      aboutSensor: "Sobre los sensores",
      aboutProbabilistic: "Sobre la probabilidad",
      hours: " horas",
      hour: " hora",
      min: "min",
      share: "Compartir pronóstico",
      newsOnForecast: "Novedades en pronósticos",
      nowItsPossibleShare:
        "¡Ahora es posible compartir pronósticos con otras personas de forma fácil y rápida! Al hacer clic en",
      onForecastScreen:
        "en la pantalla de gráficos de pronóstico, puedes enviar tus predicciones por correo electrónico.",
      close: "cerrar",
      gotIt: "Entendido",
      insights: "Eventos",
      select: "Seleccionar",
      selectInsightFromList:
        "Selecciona un evento para mostrarlo en el gráfico",
      compareInsightsWithMeteogram: "¡Compara eventos junto al meteograma!",
      selectInsight: "Seleccionar evento",
      showInsight: "Mostrar evento",
      noEventsForThisStation: "No hay eventos previstos para esta estación",
      toViewTheInsightSelectALongerPeriod:
        "En las próximas {{hours}}h no habrá eventos. Para ver el evento, selecciona un período más largo",
      nowYouCanVisualizeTheInsightOnMeteogram:
        "¡Ahora puedes visualizar tu evento junto con el meteograma! Una estación con evento se representa en el mapa en verde, solo selecciónala, elige el evento que deseas ver y ¡listo! Tu evento aparecerá en el gráfico",
      noEvent: "sin evento",
      warning: "atención",
      withEvent: "con evento",
      insightOff: "Evento desactivado",
      insightCloseToBeingActivated: "Evento próximo a activarse",
      insightOn: "Evento activado",
      confidence50: "Confianza del 50%",
      confidence80: "Confianza del 80%",
      median: "Mediana",
      windSpeed10m: "Velocidad del viento 10m",
      windSpeed50m: "Velocidad del viento 50m",
      significantWaveHeight: "Altura significativa de ola",
      closeChart: "Cerrar gráfico",
      unavailable: "No disponible",
      deterministic: "Pronóstico",
      probabilistic: "Probabilidad",
      cloud_base_height: "Altura de la base de nubes",
      windsGusts: "Vientos/Ráfagas",
      slp: "Presión a nivel del mar (Slp)",
      preciptation: "Lluvia",
      precipitationAccumulated: "Lluvia Acumulada",
      waveHeights: "Alturas de olas",
      peakPeriod: "Período pico",
      wavePower: "Potencia de ola",
      clickOnMapToOpen: "Haz clic en el mapa para abrir el gráfico de nuevo.",
      itAppearsThatYourRegion:
        "Esta región no tiene datos de probabilidad para la variable seleccionada",
      contactOurTeamToEnsure:
        "¡Contáctanos para que podamos implementar esta función para ti!✨",
      thisRegionDoesNotHavePrecip:
        "Esta región no tiene datos de precipitación mínima y máxima ni de probabilidad de lluvia.",
      thisRegionDoesNotHaveVisibility:
        "Esta región no tiene datos de visibilidad mínima, máxima ni de probabilidad de visibilidad",
      getInTouch: "Ponte en contacto",
      forecastChart: "Gráfico de pronóstico",
      probabilisticChart: "Gráfico de probabilidad",
      sensorChart: "Gráfico de datos medidos",
      metOceanForecastReport: "Informe de pronóstico MetOcean",
      reportTable: "Pronóstico tabular",
      probability: "Probabilidad",
      reflectivity: "Reflectividad (dBZ)",
      vweak: "MUY DÉBIL",
      weak: "DÉBIL",
      moderate: "MODERADO",
      strong: "FUERTE",
      vstrong: "MUY FUERTE",
      precipitationPotential: "Potencial de precipitación (mm/h)",
      radarDataUnavailable:
        "Datos de radar no disponibles. Por favor, inténtalo de nuevo más tarde.",
      waterLevel: "Nivel del agua",
      news: "¡Novedades! ✨",
    },
    forecastTable: {
      title: "Pronóstico tabular",
      tableColumnStation: "Estación",
      tableTresholdTooltipLessThan: "Umbral menor que",
      tableTresholdTooltipGreaterThan: "Umbral mayor que",
      thresholdTooltip: "Ingresa el límite para esta variable aquí.",
      dates: "Fecha/Hora",
      getDataError:
        "Ocurrió un error inesperado, ¡por favor inténtalo de nuevo!",
      selectStationLabel: "Estación",
      selectStationError:
        "Ocurrió un error inesperado, ¡por favor inténtalo de nuevo!",
      loadingForecastTableData: "Cargando pronóstico tabular...",
      forecastTablePleaseWaitAMoment:
        "Por favor, espera un momento, ¡esto puede tardar unos segundos!",
      manageColumnsModalCancel: "Cancelar",
      manageColumnsModalSave: "Guardar",
      hideColumn: "Ocultar columna",
      manageColumns: "Gestionar columnas",
      thresholdTitle: "Umbral",
      manageColumnTitle: "Gestionar columnas",
      environmentalVariableEnum: {
        weather: "Clima",
        weather_temperature: "Temperatura",
        wave: "Olas",
        wave_sea: "Ola de viento",
        wave_swell: "Oleaje",
        water_flow: "Flujo de agua",
        wind_vel: "Viento 10m",
        wind_dir: "Dir. 10m",
        slp: "Slp",
        gust: "Ráfaga 10m",
        water_level: "Nivel del agua",
        current_vel: "Vel. corriente",
        current_dir: "Dir. corriente",
        wave_height: "Altura sig.",
        wave_dir: "Dir.",
        peak_period: "Período pico",
        mean_period: "Período medio",
        wave_height_sea: "Altura",
        wave_dir_sea: "Dir.",
        peak_period_sea: "Período pico",
        wave_height_swell: "Altura",
        wave_dir_swell: "Dir.",
        peak_period_swell: "Período pico",
        precip: "Lluvia",
        wind_vel_80m: "Viento 50m",
        wind_dir_80m: "Dir. 50m",
        gust_80m: "Ráfaga 50m",
        wind_vel_100m: "Viento 100m",
        wind_dir_100m: "Dir. 100m",
        gust_100m: "Ráfaga 100m",
        wave_height_max: "Altura máx.",
        visibility: "Visibilidad",
        temp_air: "Temp. aire",
        temp_water: "Temp. agua",
        dew_point: "Punto de rocío",
        wave_power: "Potencia",
        mean_period_swell: "Período medio",
        mean_period_sea: "Período medio",
        rel_humidity: "Humedad relativa a 2m",
        precip_min_20km: "Lluvia mínima y máxima",
        precip_probability: "Probabilidad de precipitación",
        precipitation: "Lluvia",
        precip_accumulated: "Lluvia acumulada",
        water_properties: "Propiedades del agua",
        cloud_base_height: "Altura de la base de nubes",
        precip_accum_1h: "Lluvia acum. 1h",
        precip_accum_3h: "Lluvia acum. 3h",
        precip_accum_6h: "Lluvia acum. 6h",
        precip_accum_12h: "Lluvia acum. 12h",
        precip_accum_24h: "Lluvia acum. 24h",
        precip_accum_48h: "Lluvia acum. 48h",
        precip_accum_72h: "Lluvia acum. 72h",
        precip_accum_96h: "Lluvia acum. 96h",
        precip_accum_120h: "Lluvia acum. 120h",
        landslide_probability_risk: "Indice de lluvia acumulada",
        icing_probability: "Prob. de formación de hielo",
      },
    },
    forecastChartPanelMeteogramEnvironmentalButtons: {
      wave: "Ola",
      waveSea: "Ola de mar",
      waveSwell: "Oleaje",
    },
    forecastChartPanelMeteogramWeatherButtons: {
      weather: "Viento",
      weatherTemperature: "Temperatura",
    },
    forecastChartPastForecast: {
      noPastDataAvailable: "No hay datos pasados disponibles",
      pastForecast: "Pronósticos pasados",
      pastMeasurement: "Mediciones pasadas",
      time: "Hora:",
    },
    forecastChartRequestSpectraStationButton: {
      yourRequestSuccessfullySent: "¡Tu solicitud fue enviada con éxito!",
      requestSeaSwellAtThisLocation:
        "Solicitar olas de mar y oleaje en esta ubicación",
    },
    forecastChartMeteogramStore: {
      errorTryGetDataChartMeteogram:
        "Error al intentar obtener datos para el gráfico de meteograma. Por favor contáctanos.",
      noUpcomingEvents: "SIN EVENTOS PRÓXIMOS",
    },
    forecastChartProbabilisticStore: {
      errorTryGetData:
        "Error al intentar obtener datos. Por favor contáctanos.",
    },
    metOceanReport: {
      metOceanForecastReport: "Informe de pronóstico MetOcean",
      generate: "Generar",
      selectAtLeastOneVariable:
        "Selecciona al menos una variable y una estación",
      selectAtLeastOneStation:
        "Selecciona una estación para la variable seleccionada",
      selectTheVariablesAndStations:
        "Selecciona las variables y estaciones que deseas ver",
      weather: "Clima",
      wave: "Ola",
      waterFlow: "Flujo de agua",
      waterProperties: "Propiedades del agua",
      cancel: "Cancelar",
      generatingForecast: "Generando informe de pronóstico...",
      pleaseWaitAMoment:
        "Por favor, espera un momento, ¡esto puede tardar unos segundos! ⏳",
      weWereUnableToOpen:
        "No pudimos abrir el PDF porque el navegador bloqueó las ventanas emergentes. Por favor, habilita las ventanas emergentes en la configuración de tu navegador e inténtalo de nuevo.",
    },
  },
  portOfCallStore: {
    errorToGetOperationWindowData:
      "Error al obtener datos de la ventana de operación. Por favor contáctanos.",
    errorToGetDockingDynamicUkcData:
      "Error al obtener datos de UKC dinámico de atraque. Por favor contáctanos.",
  },
  unitMeasurementStore: {
    errorToAddUnitMeasurement:
      "Error al agregar unidad de medida. Por favor contáctanos",
  },
  whatIsNew: {
    whatIsNew: "¡Novedades!",
    markAllAsRead: "Marcar todo como leído.",
  },
  share: {
    shareForecast: "Compartir pronóstico",
    period: "Período",
    all: "todo",
    environmentalVariables: "Variables ambientales",
    weather: "Clima",
    selectStation: "Seleccionar estación",
    wave: "Ola",
    waterFlow: "Flujo de agua",
    recipients: "Destinatarios",
    sendMeThisEmail: "Enviarme este correo",
    externalRecipients: "Destinatarios externos",
    inviteToI4cast: "Invitar a i4cast",
    message: "Mensaje (opcional)",
    cancel: "Cancelar",
    submt: "Enviar",
    inThisFieldItsPossibleShareByEmail:
      "Comparte por correo electrónico con personas que aún no son parte de i4cast.",
    separateEmailsWithComma:
      "Separa los correos electrónicos con una coma. Ej: juan@i4sea.com, nuevo@i4sea.com",
    selectAtLeastOneEnvironmentalVariable:
      "Selecciona al menos una variable ambiental y una temporada.",
    emailsBelowAreNotValid:
      "Los correos electrónicos a continuación no son válidos.",
    selectAtLeastOneVariable: "Selecciona al menos una variable y una estación",
    youMustSelectAtLeast:
      "Debes seleccionar al menos un destinatario interno o externo",
    selectAtLeastOneStation:
      "Selecciona una estación para la variable seleccionada",
    successEmailHasSend: "¡Éxito! Tu correo electrónico ha sido enviado",
    errorSendingEmail: "Error al enviar el correo electrónico",
    helloIWouldLikeToShare:
      "Hola, me gustaría compartir contigo los datos de pronóstico de i4cast. Adjunto a este correo.",
    thereIsnotDataInThisStation:
      "No hay datos de tipo {{environmentalTypeTranslated}} en la estación: {{stationName}}. Por favor, selecciona otra estación",
    water_flow: "Flujo de agua",
    shareReportByEmail:
      "¡Comparte un informe de pronóstico por correo electrónico sin salir de i4cast!",
    forGuestUsersMustUseAnEmailDomain:
      "Invita a nuevos usuarios a i4cast. Solo se pueden invitar usuarios con el dominio de tu empresa (Ej.: juan@i4sea.com). Si necesitas invitar a otros usuarios, por favor contáctanos.",
  },
  dualList: {
    selectAll: "Seleccionar todo",
    notSelected: "No seleccionado",
    deselectAll: "Deseleccionar todo",
    selected: "Seleccionado",
    search: "Buscar",
  },
  occurrence: {
    reportOccurrence: "Reportar ocurrencia",
    reportOccurrenceDetail:
      "Reporta una ocurrencia que haya impactado tus operaciones. Basándose en esto, nuestro sistema podrá identificar y notificar pronósticos similares en el futuro.",
    cancel: "Cancelar",
    save: "Guardar",
    selectStation:
      "Selecciona la estación más cercana a la ubicación de la ocurrencia.",
    selectEnvironmentalVariables:
      "Selecciona las variables ambientales que pueden haber impactado esta ocurrencia.",
    ocurrencePeriod: "Período de la ocurrencia",
    singleDate: "Fecha única",
    period: "Inicio y fin",
    description: "Descripción de la ocurrencia",
    strongWinds: "Vientos fuertes detienen operaciones de contenedores",
    latitude: "Latitud",
    longitude: "Longitud",
    forecastHelp: "¿El pronóstico de i4cast fue correcto?",
    wantToBeNotified:
      "Quiero ser notificado cuando se pronostiquen condiciones similares",
    yes: "Sí",
    no: "No",
    wind: "Viento",
    current: "Corriente",
    wave: "Ola",
    rain: "Lluvia",
    fog: "Niebla",
    waterLevel: "Nivel del agua",
    temperature: "Temperatura",
    occurrences: "Ocurrencias",
    newOccurrence: "Reportar ocurrencia",
    search: "Buscar",
    descriptionRequired: "¡La descripción es obligatoria!",
    stationRequired: "¡La estación es obligatoria!",
    latitudeRequired: "¡La latitud es obligatoria!",
    longitudeRequired: "¡La longitud es obligatoria!",
    selectAtleastOneVariable:
      "Selecciona al menos una variable ambiental que pueda haber impactado la ocurrencia.",

    successReport: "¡Ocurrencia reportada con éxito!",
    errorReport: "¡Error al reportar la ocurrencia!",
    deleteOccurrence: "Eliminar ocurrencia",
    delete: "Eliminar",
    areYouSureWantDelete:
      "¿Estás seguro de que deseas eliminar esta ocurrencia?",
    errorEditOccurrence: "¡Error al editar la ocurrencia!",
    successEditOccurrence: "¡Éxito! Tu ocurrencia ha sido guardada",
    errorYouNeedToSelectAnOccurrence:
      "¡Error! Necesitas seleccionar una ocurrencia",
    youDonyHaveAOccurrenceYet:
      "Aún no tienes una ocurrencia. Haz clic en el botón para reportar una ocurrencia",
    addOccurrence: "Reportar ocurrencia",
    time: "Hora:",
    selectDate: "Por favor, selecciona una fecha",
    dateRequired: "¡La fecha es obligatoria!",
    exactLocation:
      "¿Te gustaría proporcionar la ubicación exacta del incidente? (opcional)",
    selectOption: "¡Selecciona una opción!",
    startDateMustBeLessThanEndDate:
      "La fecha de inicio debe ser anterior a la fecha de fin",
    windInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de velocidad del viento, dirección y ráfagas para identificar eventos similares.",
    waveInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de altura significativa de ola, dirección y período pico para identificar eventos similares.",
    rainInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de precipitación para identificar eventos similares.",
    fogInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de visibilidad para identificar eventos similares.",
    temperatureInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de temperatura del aire para identificar eventos similares.",
    waterLevelInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de nivel del agua para identificar eventos similares.",
    currentInfo:
      "Al seleccionar esta opción, i4cast utilizará datos de velocidad y dirección de la corriente para identificar eventos similares.",
    forecastCorrect:
      "En tu opinión, ¿el pronóstico de i4cast te ayudó a identificar esta ocurrencia?",
    occurrencesAreEventsThatImpactYourOperation:
      "Las ocurrencias son eventos que pueden impactar tus operaciones. Reporta ocurrencias para que i4cast sea más inteligente. Identificaremos pronósticos similares en el futuro y serás notificado.",
    startHourIsRequired: "La hora de inicio es obligatoria",
    endHourIsRequired: "La hora de fin es obligatoria",
    importOccurrence: "Importar ocurrencia",
    selectFileToImport:
      "Selecciona un archivo para importar (pdf, excel, word y txt):",
    import: "Importar",
    successOnImport: "¡Éxito! Hemos recibido tu archivo con las ocurrencias.",
    youNeedToChooseFile: "¡Selecciona un archivo para importar!",
    weAreProcessingTheWorkSheet:
      "Estamos procesando la hoja de cálculo con las ocurrencias. Te notificaremos pronto cuando estén completadas.",
    theSelectedFileExceedsMaxium:
      "El archivo seleccionado excede el tamaño máximo permitido de 5MB.",
    importYourOccurrencesSpreadSheet:
      "¿Ya tienes un documento con registro de eventos climáticos? ¡Impórtalo aquí y lo registraremos por ti!",
    successfullyUploaded: "¡Cargado con éxito!",
    yourFileWithOccurrenceWasSent:
      "Tu archivo con ocurrencias fue enviado con éxito y tan pronto como estén registradas en i4cast, ¡serás notificado por correo electrónico!",
    iGotIt: "¡Entendido!",
    selectAFile: "Seleccionar archivo",
    selectedFile: "Archivo seleccionado:",
    noFileSelected: "Ningún archivo seleccionado",
    newsInOccurrence: "Novedades en ocurrencias",
    nowItsPossibleImportSpreadSheet:
      "¡Ahora es posible importar una hoja de cálculo o documento con tus ocurrencias, facilitando el registro y haciendo i4cast más inteligente!",
    try: "Probar",
  },
  feedback: {
    successSendFeedback: "¡Éxito! Tu comentario ha sido enviado",
    errorSendFeedback: "Error al enviar el comentario",
    thisFieldIsRequired: "Este campo es obligatorio",
    send: "Enviar",
    yes: "Sí",
    no: "No",
    typeYourAnswerHere: "Escribe tu respuesta aquí",
  },
  manageStation: {
    manageStation: "Gestor de estaciones",
    configureWhichStationViewHistoricalData:
      "Configura qué estaciones deseas ver con datos históricos",
    name: "Nombre",
    region: "Región",
    latLon: "Ubicación (lat, lon)",
    historicalData: "Datos históricos",
    search: "Buscar",
    station: "Estación",
    page: "Página",
    of: "de",
    filterBy: "Filtrar por",
    forecastDataType: "Tipo de datos de pronóstico",
    weather: "Clima",
    wave: "Ola",
    waveSpectra: "Espectro de olas",
    waveSea: "Ola de mar",
    waveSwell: "Oleaje",
    waterFlow: "Flujo de agua",
    dataHistory: "Historial de datos",
    environmentalType: "Tipo ambiental",
    selectAtLeastOneEnvironmentalType: "Selecciona al menos un tipo ambiental",
    save: "Guardar",
    successEditStation: "¡Éxito! Tu estación ha sido guardada",
    errorEditStation: "¡Error al editar la estación!",
    errorNoEnvironmentalDataAtStation:
      "¡Hay tipos ambientales no disponibles para esta estación!",
    enterAtLeastThreeLetters: "Ingresa al menos 3 letras",
    notFound: "No encontrado",
    clean: "Limpiar",
  },
  analyticsReporting: {
    period: "Período de análisis",
    environmentalType: "Tipo ambiental",
    weather: "Clima",
    location: "Ubicación",
    environmentalVariable: "Variable ambiental",
    windSpeed: "Velocidad del viento",
    direction: "Dirección",
    minimum: "Mínimo",
    maximum: "Máximo",
    knots: "nudos",
    forecastAdvancePeriod: "Período de cada pronóstico",
    before: "antes",
    generateAnalysis: "Generar análisis",
    hoursEarned: "Horas ganadas",
    hoursGainIsHowMuchMoreAccuratei4castWas:
      "Las horas ganadas es cuánto más preciso fue i4cast en relación con el modelo global en horas.",
    moreThanGlobal: "más certero que el modelo global",
    eventsCaptured: "Eventos capturados",
    fillINTheFieldsBelowViewData:
      "Completa los campos a continuación para ver los datos",
    eventsCapturedRepresentTheQuantityOfEvents:
      "Los eventos capturados representan la cantidad de eventos que i4cast capturó más que el modelo global",
    degrees: "grados",
    region: "Región",
    selectRegion: "Selecciona una región",
    selectLocation: "Selecciona una ubicación",
    selectEvent: "Selecciona un evento",
    isGreaterOrEqual: "Mayor o igual",
    isLessOrEqual: "Menor o igual",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    requiredField: "Campo obligatorio",
    isGreaterOrEqualThan: "Mayor o igual que",
    isLessOrEqualThan: "Menor o igual que",
    between: "entre",
    to: "a",
    globalModel: "Modelo global",
    sensor: "Medido",
    numberOfEvents: "Número de eventos",
    events: "Eventos",
    comparisonOfi4castForecastPerformance:
      "Comparación del rendimiento del pronóstico de i4cast con el pronóstico global.",
    fillAtLeastOneField: "Completa al menos uno de los campos",
    generatingAnalysis: "generando análisis...",
    moreAssertiveForecastHours: "Pronóstico más certero que el modelo global",
    weAreGeneratingAnalysis:
      "Estamos generando tu análisis, esto puede tardar unos segundos.",
    weDoNotHaveDataAvailable:
      "No tenemos datos disponibles para el filtro seleccionado. Ingresa nueva información para intentar de nuevo.",
    timeCalculation: "Cálculo de tiempo",
    timeCalculationIsAPercentageOfTime:
      "El cálculo de tiempo representa el porcentaje de tiempo que la condición filtrada estuvo activa en tu región",
    ofTheTimeWithWinds: "del tiempo con vientos",
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "November",
    december: "Diciembre",
    mostFrequently: "Más frecuente en",
    errorGeneratingAnalytics: "Error al generar el análisis",
    theMaximumValueMustBeGreater:
      "El valor máximo debe ser mayor o igual que el valor mínimo",
    ofTheTimeWithWindsGreaterOrEqual: "del período con viento mayor o igual",
    ofTheTimeWithWindsLessOrEqual: "del período con viento menor o igual",
    someMonthsMayNotBeDisplayed:
      "Algunos meses pueden no mostrarse en el gráfico debido a datos insuficientes para el análisis de rendimiento.",
    monthlyAverageWindSpeed: "Velocidad media mensual del viento",
    windDirection: "Dirección del viento",
    average: "Promedio",
    standardDeviation: "Desviación estándar",
    eventFrequency: "Frecuencia de eventos",
    first: "Primero",
  },
  eventHistory: {
    selectStationAndDefinePeriod:
      "Selecciona una estación y fecha inicial para ver un análisis comparativo del pronóstico durante un período de 5 días.",
    eventHistory: "Historial de eventos",
    selectStation: "Selecciona una estación",
    startDate: "Fecha inicial",
    endDate: "Fecha final",
    weather: "Clima",
    wave: "Ola",
    waterFlow: "Flujo de agua",
    waterLevel: "Nivel del agua",
    current: "Corriente",
    sensor: "Sensor",
    global: "Modelo global",
    noGlobalModelDataFound:
      "No se encontraron datos del modelo global para el filtro seleccionado",
    noSensorDataFound:
      "No se encontraron datos del sensor para el filtro seleccionado",
    noi4castDataFound:
      "No se encontraron datos de i4cast para el filtro seleccionado",
    selectStationToViewData: "Selecciona una estación para ver los datos",
    environmentalVariable: "Variable ambiental",
  },
  eventAnalysis: {
    eventAnalysis: "Análisis de eventos",
    occurrence: "Ocurrencia",
    period: "Período",
    location: "Ubicación",
    weather: "Clima",
    wave: "Ola",
    waterFlow: "Flujo de agua",
    wind: "Viento",
    gust: "Ráfaga",
    rain: "Lluvia",
    minimumValue: "Mínimo de",
    averageValue: "Promedio de",
    maxValue: "Máximo",
    accumulatedValue: "Acumulación",
    peakValue: "Pico a las",
    averageWindGust: "Promedio viento | Ráfaga",
    maxWindGust: "Máximo viento | Ráfaga",
    averageWavePeriod: "Promedio altura | Período",
    maxWavePeriod: "Máximo altura | Período",
    minWaterFlowCurrent: "Mínimo corriente",
    maxWaterFlowCurrent: "Máximo corriente",
    timeSeries: "Serie temporal",
    theChartBelowShows:
      "El gráfico a continuación representa una serie temporal de datos brutos del período de la ocurrencia.",
    significantWaveHeight: "Altura significativa de ola",
    wavePeakPeriod: "Período pico de ola",
    waterLevel: "Nivel del agua",
    current: "Corriente",
    selectOccurrence: "Selecciona una ocurrencia",
    selectAnOccurrenceToBegin:
      "Selecciona una ocurrencia para comenzar tu análisis",
    knots: "nudos",
    latitude: "latitud",
    longitude: "longitud",
    noi4castDataFound:
      "No se encontraron datos de i4cast para la ocurrencia seleccionada",
  },
  environmentalVariableStore: {
    windSpeed: "Viento - Velocidad a 10m",
    windDirection: "Viento - Dirección a 10m",
    windGusts: "Viento - Ráfaga a 10m",
    waterLevel: "Nivel del agua",
    currentVelocity: "Corriente - Velocidad",
    currentDirection: "Corriente - Dirección",
    waveHeight: "Ola - Altura significativa",
    waveDirection: "Ola - Dirección del pico",
    peakPeriod: "Ola - Período pico",
    meanPeriod: "Ola - Período medio",
    seaWaveHeight: "Ola de mar - Altura significativa",
    seaWaveDirection: "Ola de mar - Dirección del pico",
    seaPeakPeriod: "Ola de mar - Período pico",
    swellWaveHeight: "Oleaje - Altura significativa del oleaje",
    swellWaveDirection: "Oleaje - Dirección del pico",
    swellPeakPeriod: "Oleaje - Período pico del oleaje",
    precipitation: "Lluvia",
    windSpeedAt80m: "Viento - Velocidad a 50m",
    windDirectionAt80m: "Viento - Dirección a 50m",
    windGustsAt80m: "Viento - Ráfaga a 50m",
    windSpeedAt100m: "Viento - Velocidad a 100m",
    windDirectionAt100m: "Viento - Dirección a 100m",
    windGustsAt100m: "Viento - Ráfaga a 100m",
    maximumWaveHeight: "Ola - Altura máxima",
    visibility: "Visibilidad",
    airTemperature: "Temperatura del aire",
    dewPoint: "Punto de rocío",
    precicip_min_20km: "Lluvia mínima y máxima",
    precicip_probability: "Probabilidad de precipitación",
  },
  environmentalVariableEnum: {
    weather: "Clima",
    weather_temperature: "Temperatura",
    wave: "Olas",
    wave_sea: "Ola de viento",
    wave_swell: "Oleaje",
    water_flow: "Flujo de agua",
    wind_vel: "Viento 10m",
    wind_dir: "Dirección 10m",
    slp: "Slp",
    gust: "Ráfaga 10m",
    water_level: "Nivel del agua",
    current_vel: "Velocidad de corriente",
    current_dir: "Dirección de corriente",
    wave_height: "Ola - altura significativa",
    wave_dir: "Ola - dirección",
    peak_period: "Ola - período pico",
    mean_period: "Ola - período medio",
    wave_height_sea: "Ola de viento - altura",
    wave_dir_sea: "Ola de viento - dirección",
    peak_period_sea: "Ola de viento - período pico",
    wave_height_swell: "Oleaje - altura",
    wave_dir_swell: "Oleaje - dirección",
    peak_period_swell: "Oleaje - período pico",
    precip: "Lluvia",
    wind_vel_80m: "Viento 50m",
    wind_dir_80m: "Dirección 50m",
    gust_80m: "Ráfaga 50m",
    wind_vel_100m: "Viento 100m",
    wind_dir_100m: "Dirección 100m",
    gust_100m: "Ráfaga 100m",
    wave_height_max: "Ola - altura máx.",
    visibility: "Visibilidad",
    probability: "Probabilidad (%)",
    visibility_maximum_20km: "Visibilidad máx.",
    visibility_minimum_20km: "Visibilidad mínima y máxima",
    visibility_probability_1000m: "Prob. visibilidad menor que 1km (%)",
    visibility_probability_1500m: "Prob. visibilidad menor que 1.5km (%)",
    visibility_probability_2000m: "Prob. visibilidad menor que 2km (%)",
    temp_air: "Temperatura del aire",
    temp_water: "Temperatura del agua",
    dew_point: "Punto de rocío",
    wave_power: "Potencia",
    mean_period_swell: "Oleaje - período medio",
    mean_period_sea: "Ola de viento - período medio",
    rel_humidity: "Humedad relativa a 2m",
    precip_min_20km: "Lluvia mínima y máxima",
    precip_probability: "Probabilidad de precipitación",
    precipitation: "Lluvia",
    precip_accumulated: "Lluvia acumulada",
    precip_accum_1h: "Lluvia acum. 1h",
    precip_accum_3h: "Lluvia acum. 3h",
    precip_accum_6h: "Lluvia acum. 6h",
    precip_accum_12h: "Lluvia acum. 12h",
    precip_accum_24h: "Lluvia acum. 24h",
    precip_accum_48h: "Lluvia acum. 48h",
    precip_accum_72h: "Lluvia acum. 72h",
    precip_accum_96h: "Lluvia acum. 96h",
    precip_accum_120h: "Lluvia acum. 120h",
    landslide_probability_risk: "Indice de lluvia acumulada",
    icing_probability: "Prob. de formación de hielo",
  },
  utils: {
    now: "Ahora mismo",
    minAgo: "hace {{minutes}}min",
    oneHourAgo: "hace 1 hora",
    hoursAgo: "hace {{hours}}h",
    oneDayAgo: "hace 1 día",
    daysAgo: "hace {{days}} días",
    longTimeAgo: "Hace mucho tiempo",
  },
  riverForecastChart: {
    extremeHigh: "Extremadamente alto",
    veryHigh: "Muy alto",
    high: "Alto",
    mostLikely: "Escenario base",
    low: "Bajo",
    veryLow: "Muy bajo",
    extremeLow: "Extremadamente bajo",
    sensor: "Sensor",
  },
  "404": {
    oopsPageNotFound: "Ups, página no encontrada",
    goToLogin: "Ir al inicio de sesión",
  },
  "500": {
    oopsAnErrorOccurred: "Ups, ocurrió un error",
    tryAgain: "Intentar de nuevo",
  },
  operationServices: {
    serviceRemovedSuccess: "¡Servicio eliminado con éxito!",
    removalFailedContactUs: "Error en la eliminación. Contáctanos",
    serviceUpdatedSucess: "¡Servicio actualizado con éxito!",
    serviceCreatedSucess: "¡Servicio creado con éxito!",
    name: "Nombre",
    description: "Descripción",
    recurrence: "Recurrencia",
    deleteService: "Eliminar servicio",
    areYouSureWantDeleteThisService:
      "¿Estás seguro de que deseas eliminar este servicio?",
    delete: "Eliminar",
    cancel: "Cancelar",
    loading: "Cargando",
    noData: "No hay datos disponibles",
    serviceEdit: "Editar servicio",
    serviceCreate: "Crear servicio",
    serviceName: "Nombre del servicio",
    serviceCost: "Costo del servicio",
    shipMaintance: "Mantenimiento de barco",
    moneyValue: "10,000.00",
    routineMaintance: "Rutina de mantenimiento por la mañana",
    repeatEvery: "Repetir cada",
    weeks: "semanas",
    repeat: "Repetir",
    start: "Inicio",
    selectTime: "Seleccionar fecha",
    end: "Fin",
    newShift: "Nuevo turno",
    startIn: "Comenzar en",
    advanceHiring: "Tiempo de anticipación de contratación",
    hours: "horas",
    editService: "Editar servicio",
    createService: "Crear servicio",
    services: "Servicios",
    selectDate: "Seleccionar fecha",
    nameIsRequired: "El nombre es obligatorio",
    startTimeMustBeBeforeEndTime:
      "¡La hora de inicio debe ser anterior a la hora de fin!",
    startDateRequired: "¡La fecha de inicio es obligatoria!",
    endDateRequired: "¡La fecha de fin es obligatoria!",
    seleactAtLeastOneDay: "Selecciona al menos un día",
    startTimeRequired: "¡La hora de inicio es obligatoria!",
    endTimeRequired: "¡La hora de fin es obligatoria!",
    doestHappenAgain: "No se repite",
    mondayFriday: "Lunes a viernes",
    weekly: "Semanalmente",
    custom: "Personalizado",
    multipleShiftsDetected:
      "Se han detectado múltiples turnos con las mismas fechas y horas.",
    sunday: "D",
    monday: "L",
    tuesday: "M",
    wednesday: "M",
    thursday: "J",
    friday: "V",
    saturday: "S",
    currency: "Moneda",
    whatHappensWhenRegistering: "¿Qué sucede al registrar un servicio?",
    yourServiceAndShiftsWill:
      "Tu servicio y turnos aparecerán en el gráfico Gantt, permitiéndote visualizar mejor tu horario y hacer seguimiento de los eventos de pronóstico para optimizar tu operación.",
    visualizeYourOperations:
      "¡Visualiza tus operaciones con precisión! Registra un servicio y monitorea las condiciones del mar y del clima.",
  },
  time: {
    minutesAgo: "hace {{minutes}}m",
    inMinutes: "en {{minutes}}m",
    hoursAgo: "hace {{hours}}h",
    inHours: "en {{hours}}h",
    hoursMinutesAgo: "hace {{hours}}h {{minutes}}m",
    inHoursMinutes: "en {{hours}}h {{minutes}}m",
  },
  radarLegend: {
    showRainRdar: "Mostrar radar de lluvia",
    new: "Nuevo",
    nowcast: "Nowcast",
    oneHourNowcast: "hasta 1h nowcast",
    light: "Ligera",
    moderate: "Moderada",
    heavy: "Intensa",
    rain: "Lluvia",
    snow: "Nieve",
    precipitation: "Lluvia",
    error: {
      title: "Error de radar",
      unavailable: "Datos de radar temporalmente no disponibles",
      noData: "No hay datos de radar disponibles",
      connectionLost: "Conexión perdida",
    },
  },
  layer: {
    selectLayer: "Capas",
    weather: "Clima",
    noLayer: "Sin capa",
    wind: "Viento 10m",
    gust: "Ráfaga 10m",
    waves: "Olas",
    airTemp: "Temp. aire",
    visibility: "Visibilidad",
    rain: "Lluvia",
    cloudCover: "Cobertura de nubes",
    radars: "Radares",
    weatherRadar: "Radar meteorológico",
    layers: "Capas",
    airPressure: "Presión",
    tooltipRemoveLayer: "Eliminar capa",
    nowcast: "Nowcast",
    waveHeight: "Altura significativa de ola",
    waveHeightMax: "Altura máx. de ola",
    wavePower: "Potencia de ola",
    comingSoon: "¡Próximamente!",
    noWaveDataRegion:
      "No hay datos de olas disponibles para tu región. Contáctanos para habilitarlos.",
    noWeatherDataRegion:
      "No hay datos meteorológicos disponibles para tu región. Contáctanos para habilitarlos.",
    maplayerDisclaimer:
      "El gráfico de pronóstico en ubicaciones puntuales puede diferir de los mapas debido a actualizaciones de Machine Learning mejoradas y más frecuentes.",
    startUpLayer: "Capa de inicio",
    typeLayer: "Ingresa la capa aquí...",
    initialLayer: "Capa mostrada al iniciar el mapa",
    noLayerDataWasFound:
      "Error al cargar los datos de la capa. Contacta al soporte si el problema persiste.",
  },
  cities: {
    utc: "UTC (Tiempo Universal Coordinado)",
    gmt: "GMT (Hora del Meridiano de Greenwich)",

    saoPaulo: "São Paulo",
    recife: "Recife",
    bahia: "Bahía",
    buenosAires: "Buenos Aires",
    santiago: "Santiago",
    bogota: "Bogotá",
    lima: "Lima",
    mexicoCity: "Ciudad de México",

    newYork: "Nueva York",
    chicago: "Chicago",
    denver: "Denver",
    losAngeles: "Los Ángeles",
    toronto: "Toronto",
    vancouver: "Vancouver",

    london: "Londres",
    lisbon: "Lisboa",
    paris: "París",
    berlin: "Berlín",
    madrid: "Madrid",
    rome: "Roma",
    stockholm: "Estocolmo",
    copenhagen: "Copenhague",
    amsterdam: "Ámsterdam",
    athens: "Atenas",

    tokyo: "Tokio",
    shanghai: "Shanghái",
    seoul: "Seúl",
    bangkok: "Bangkok",
    mumbai: "Bombay",
    dubai: "Dubái",

    sydney: "Sídney",
    auckland: "Auckland",
  },
  news: {
    news: "💡Novedad - Eventos operacionales",
    title: "Nuevo recorrido simplificado de eventos",
    paragraph1:
      "Repensamos la forma de crear eventos, ahora empiezas definiendo lo que quieres monitorear, sin tener que decidir todo de una vez.",
    paragraph2Part1: "De esta manera,",
    paragraph2Bold1:
      "primero defines lo que quieres seguir y ajustas el uso después,",
    paragraph2Part2: "con más claridad y menos esfuerzo, según sea necesario.",
    paragraph3Part1: "Como parte de esta evolución,",
    paragraph3Bold: "Insight ahora se llama Evento",
    paragraph3Part2: ", reflejando este nuevo recorrido simplificado.",
    exploreEvents: "Explorar Eventos",
    gotIt: "¡Entendido!",
  },
  userPhoneEmailVerify: {
    iAgreeReceive:
      "Acepto recibir alertas vía WhatsApp sobre condiciones de riesgo.",
    updateYourContact: "Actualiza tus datos de contacto en i4cast",
    keepAlwaysUpdated:
      "¡Mantente un paso adelante! Recibe alertas de riesgo en WhatsApp.",
    typeEmail: "Ingresa tu correo electrónico",
    invalidEmail: "Correo electrónico inválido",
    email: "Correo electrónico",
    cellPhone: "Teléfono celular",
    confirm: "Confirmar",
    weSentATextToYourPhone: "Enviamos un código por SMS al número:",
    invalidCode: "Código inválido",
    resentCode: "Reenviar código",
    back: "Anterior",
    confirmCode: "Confirmar código",
    maximumAttempts:
      "Se excedió el número máximo de intentos. Por favor, inténtalo de nuevo en 10 minutos.",
    successYouPhone:
      "¡Éxito! Tu correo electrónico y número de teléfono han sido guardados.",
    emailAlreadyInUse: "Este correo electrónico ya está en uso.",
    phoneAlreadyInUse: "Este número de teléfono ya está en uso.",
  },
  locations: {
    createLocation: "Crear ubicación",
    editLocation: "Editar ubicación",
    area: "Área",
    locations: "Ubicaciones",
    description: "Crea y edita ubicaciones registradas por ti o tu empresa.",
    name: "Nombre",
    coordinateType: "Tipo de coordenada",
    coordinatesType: "Tipo de coordenadas",
    coordinates: "Coordenadas",
    coordinatesCount: "coordenada(s)",
    actions: "Acciones",
    point: "Punto",
    multipoint: "Múltiples puntos",
    route: "Ruta",
    error: "Error",
    deleteConfirmation: "¿Estás seguro de que deseas eliminar esta ubicación?",
    locationName: "Nombre de la ubicación",
    locationNamePlaceholder: "Ingresa el nombre de la ubicación",
    mapConfiguration: "Configuración del mapa",
    save: "Guardar",
    cancel: "Cancelar",
    requiredField: "Este campo es obligatorio",
    monitoredArea: "Área monitoreada",
    create: "Crear",
    createLocationButton: "Crear ubicación",
    update: "Actualizar",
    saveChanges: "Guardar cambios",
    edit: "Editar",
    clear: "Limpiar",
    delete: "Eliminar",
    deleteLocation: "Eliminar ubicación",
    drawArea: "Dibujar un área",
    importGeojson: "Importar GeoJSON",
    dropTheFile: "Suelta el archivo aquí...",
    dragAndDrop:
      "Arrastra y suelta un archivo GeoJSON aquí, o haz clic para buscar.",
    errorLoadingLocations: "Error al cargar las ubicaciones",
    errorLoadingLocation: "Error al cargar la ubicación",
    errorCreatingLocation: "Error al crear la ubicación",
    errorCreatingLocationNameInUse: "El nombre de la ubicación ya está en uso",
    errorUpdatingLocation: "Error al actualizar la ubicación",
    errorDeletingLocation: "Error al eliminar la ubicación",
    errorDeletingLocationInUse:
      "Esta ubicación no se puede eliminar porque está siendo utilizada por una alerta",
    enablePagination: "Habilitar paginación",
    disablePagination: "Deshabilitar paginación",
    noLocationsYet: "Aún no tienes ninguna ubicación registrada",
    noLocationsFound: "No se encontraron ubicaciones para el término buscado",
    pleaseDrawAnArea:
      "* Por favor, dibuja un área en el mapa o importa una existente.",
    invalidArea:
      "Asegúrate de que el polígono esté ubicado cerca de tus estaciones registradas.",
    coordinatesRequired: "Las coordenadas son obligatorias",
    searchPlaceholder: "Buscar ubicación...",
    saveGeofence: "Guardar geocerca",
  },
  event: {
    selectRiskCategory: "Selecciona una categoría de riesgo",
    selectRiskDescription:
      "Elige una opción y sugeriremos las condiciones del evento.",
    pleaseSelectRisk: "* Por favor, seleccione un tipo de riesgo",
    pleaseAddCondition: "* Por favor, agregue al menos una condición",
    aboutRisk: "Sobre el riesgo",
    aboutRiskGenericDescription:
      "Indica condiciones de riesgo basadas en variables meteorológicas.",
    riskDescription_noCategory: "Evento sin categoría específica de riesgo.",
    riskDescription_extremeHeat:
      "Temperaturas muy elevadas que afectan a las personas, equipos y operaciones.",
    riskDescription_extremeWind:
      "Vientos fuertes y persistentes que pueden causar daños e interrupciones.",
    riskDescription_extremeRain:
      "Lluvias intensas en corto período, con riesgo de acumulación de agua.",
    riskDescription_landslide:
      "Saturación del suelo por lluvias persistentes, aumentando el riesgo de deslizamientos.",
    riskDescription_wildfire:
      "Condiciones favorables para la propagación del fuego en áreas naturales.",
    riskDescription_treeFall:
      "Caída de árboles provocada por vientos fuertes y suelo saturado.",
    riskDescription_roofDamage:
      "Daños estructurales en techos causados por vientos intensos.",
    riskDescription_roughSea:
      "Olas altas y mar agitado que dificultan las actividades marítimas.",
    riskDescription_fog: "Formación de niebla que reduce la visibilidad.",
    riskDescription_lowVisibility:
      "Visibilidad reducida que compromete desplazamientos y operaciones.",
    riskDescription_lightningStorm:
      "Tormentas con posibilidad de descargas eléctricas.",
    // Risk type labels (internationalized)
    riskLabel_roughSea: "Marejada",
    riskLabel_flooding: "Inundación",
    riskLabel_extremeWind: "Vendaval",
    riskLabel_treeFall: "Caída de\nárboles",
    riskType: "Tipo de riesgo",
    riskLabel_roofDamage: "Daños en\ntechos",
    riskLabel_landslide: "Deslizamiento\nde tierra",
    riskLabel_extremeHeat: "Calor extremo",
    riskLabel_wildfire: "Incendio\nforestal",
    riskLabel_fog: "Niebla",
    riskLabel_lowVisibility: "Baja\nvisibilidad",
    riskLabel_lightningStorm: "Incidencia\nde rayos",
    riskLabel_noCategory: "Sin\ncategoría",
    riskCategoryUnavailable:
      "No disponible en su región, contáctenos para información.",
    notAvailable: "No disponible",
    eventConditions: "Condiciones del evento",
    noConditionsAvailable:
      "No hay condiciones disponibles para este tipo de riesgo.",
    seeMoreRiskTypes: "Ver más tipos de riesgo",
    collapseRiskOptions: "Contraer opciones",
    i4castSuggestion: "Sugerido por i4cast",
    backToI4castSuggestion: "Volver a sugerencia i4cast",
    selectAlertType: "Selecciona el tipo de Evento:",
    alertTypeChangeWarningTitle: "Atención al cambio de tipo de evento",
    alertTypeChangeDescription:
      "Al cambiar el tipo de evento, las condiciones también cambian. ¿Cómo deseas continuar?",
    useTypeDefault: "Usar condiciones predeterminadas",
    keepMyChanges: "Mantener mis condiciones",
    conditionsEmptyStateTitle:
      "Agrega una condición climática que pueda afectar tu operación",
    conditionsEmptyStateCreateButton: "Crear condición",
    conditionsEmptyStateSubtext:
      "o selecciona un riesgo arriba y usa nuestras sugerencias.",
    eventAction: "Acción del evento",
    eventActionTooltip:
      "Define cómo las condiciones climáticas afectan su operación. En modo Restrictivo, las condiciones limitan o impiden la operación. En modo Permisivo, las condiciones son necesarias para que la operación ocurra.",
    restrictive: "Restrictivo",
    restrictiveTooltip:
      "Utilizado para condiciones climáticas que pueden restringir su operación.",
    permissive: "Permisivo",
    permissiveTooltip:
      "Utilizado para condiciones climáticas que permiten que su operación ocurra.",
    color: "Color",
    colorOnDashboard: "Color en el panel",
    eventDescriptionLabel: "Descripción",
    eventDescriptionPlaceholder: "Describe el evento...",
    red: "Rojo",
    orange: "Naranja",
    yellow: "Amarillo",
    blue: "Azul",
    wantAlerts: "Quiero ser alertado del pronóstico",
  },
};
